import React from 'react';

const DRMapStaticElements: React.FC = () => {
  return (
    <g className="future-city-resources-map-bg">
      <defs>
        <linearGradient
          id="bb03fb45-26e1-43c9-96ab-8faf0428131f"
          x1="908.23"
          y1="-184.28"
          x2="819.39"
          y2="987.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.3" stopColor="#0d2b6c" />
          <stop offset="0.34" stopColor="#303472" />
          <stop offset="0.4" stopColor="#68427c" />
          <stop offset="0.45" stopColor="#8b4b83" />
          <stop offset="0.48" stopColor="#984e85" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
        <linearGradient
          id="a905eec1-d67d-4044-bb46-a67ebe5d362a"
          x1="950.63"
          y1="1141"
          x2="716.4"
          y2="503.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.45" stopColor="#0d2b6c" />
          <stop offset="0.53" stopColor="#484572" />
          <stop offset="0.63" stopColor="#966779" />
          <stop offset="0.72" stopColor="#cf817e" />
          <stop offset="0.79" stopColor="#f29082" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
        <linearGradient
          id="a6e44ce5-21ac-4f45-af8e-ae59f269cac2"
          x1="102"
          y1="904"
          x2="1625"
          y2="904"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" />
        </linearGradient>
        <image
          id="a986ed6f-0b40-453e-a94c-dec2035ef9ff"
          width="86"
          height="86"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABWCAYAAABVVmH3AAAACXBIWXMAAAsSAAALEgHS3X78AAAFAElEQVR4Xu3a204bVxSA4X/tPWObk7FrjOMEgVVoVZFLrivlJcgj9DXivA68BPdRLuMoKkmtJDJJiVsDBjynvXoRVNFITdSqu55I+7+zNJalT0trDh5RVUL/feZLB4T+XQHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWU9GXDihDAnL7s0Lp3z0t9cQKyGMwB2D6R0f2AMz+4aEB5FPssiUlfvFYDsEMBgNbr9dtEcem3unoyXDouuNxcbK3V/RByzq9ZYX9iDocxrVVV7XxUjVJojhWVZtl6TSKZpyepuzu5v2S4pZuFQjIwxvUarO5EMlCo8gqnTjO7tmYbrEctxYXWabdrox4aksnelOpJlZA+iDj4+O4tRYtVKk1jInXjWinUFZQzQU31kLf2YqcXl64KS9epI8ePCgo2dSWaWJlH8w3x8fxvZap1bRaj03cRt0mBd8J7gcjfA+mZ23cydQ2Kstu4WxnJ358dGQp2QmtLBP7506l0aitVN1Kmrp1o7Illh1Reg5tGjRxmLc497NaXmpFR5pmZ+nUXHe7o+yE8pzQ5n4dKyAHt3YqVV3N03Td2HgD1W11bkdENkVMXSER1UiMZIWS2TRSVGy84s5OTjevum2SPhTC/K915w7bBxkwsLXVbjWqal216BRqt0zhvgXZRkwPkTuoWwJJAQs4AYw6WzipqImieLEm57zX0dO3qe7t5Z//Vf/NdccKyDOQOnVbVLJaXtBwOV2D9kC2RaQH3FXVNZAG0ATuoGwZZNuhOw7dMmhHrq9Xs4u8drfVso9LsG/nPrH3OZLz03Ub2UaFmCXBNsSYNVXaoC1E6jhdRIiASFFFJAMSVWZGZOpUJhq5SWwq52nVmN2PqHNdBXOd2H+UfpxCIyKARTUS1IIaQyHxl77/Pzd32Gc80Hq7Xkg1SjGVS4WJOvcB5RRkjOo5whVCgjBTp1coZ4KMQT6IkTFiz3IrV7lLM5LEDeY8rTBnWAW9D3rOeWHTeBZZJibixCFD0JeqOgRGwBhkgjIRMe9B34D+IvDKqXkD5ldNuEhnlWQ0HhePSnDJNfcd2wc9YLcYnA2TqmmeU7ViJFM1cY5qgXNqxBYqrKqSIbxT5RVwLLghJj9JZ9FvEUyz9ml6t71XzH3BUgLYm8lyh71eNhgOodHQlWqlSFNXGBXEWlGnBdAUSJ1zIzFyLCKvMrUjveL3TPRyrd1OrlkrzQ1CWe684Obhy4/Hx9FVy9RgYTWylU6hbsuobDpDA8hUeSe4Ida+vSYfs+ym0E0B1y8JKpQL9rMPYVBWCtVcIjM2af5ec/NBnLu47HSSR1C6hzBzXwW3U1AB9nd28tZwOKO5cGbdleZx7VqKZCEiKtJZeim1aLLUZBrRSS/BUTJUKNnE3io86PaU7oPb7fWy2cns2k6yi2qeTxpra5Npkky7r18nZUaF8sIC6ENw7O7mGxsb6eXz50kTkmdPnmQ/7e2VGhXKuwr+0tf493epTl5/19cA+WllXgVfdQHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWUwHWU38AOI1UHEHHbNUAAAAASUVORK5CYII="
        />
        <image
          id="aeff00c8-713c-4c6e-aa65-8a1c4e61f8a2"
          width="93"
          height="93"
          xlinkHref="data:image/png;base64,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"
        />
        <image
          id="f7707b16-cd19-49ca-ab7b-c4865bdcfa62"
          width="93"
          height="93"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
      <g
        id="bbe4a706-9d93-4670-9e24-437466fe1522"
        transform="translate(-103 -36)"
      >
        <g id="be5a3cf5-2f25-4c84-a25c-eb3f79cab94d">
          <rect
            x="102"
            y="17"
            width="1523"
            height="777"
            fill="url(#bb03fb45-26e1-43c9-96ab-8faf0428131f)"
          />
          <g>
            <rect
              x="102"
              y="653"
              width="1523"
              height="502"
              fill="url(#a905eec1-d67d-4044-bb46-a67ebe5d362a)"
            />
            <path
              d="M1624,654v500H103V654H1624m1-1H102v502H1625V653Z"
              fill="url(#a6e44ce5-21ac-4f45-af8e-ae59f269cac2)"
            />
          </g>
          <path
            d="M1010,652c-12.18,21.16-21,69.11-161,97.68-46.38,9.46-58.08,50-114,53.45-78.29,4.8,129.37-2.62,55,26.87-3.11,1.23-4.08,2.91-4.1,3-1.79,12.14,751.48,237,873.1,32,23.82-40.14,19.55-90.27,6-137q-7.45-38-14.9-76Z"
            fill="#41275b"
          />
          <path
            d="M101,828c419,0,350,49,458-13,37.74-21.67,232.47-39,212-71s25.83-59,73-49,90-43,90-43l-832,1Z"
            fill="#3d2651"
          />
        </g>
        <g>
          <g opacity="0.51">
            <polygon
              points="1062.19 94.69 1066.57 97.08 1062.19 99.48 1059.79 103.87 1057.39 99.48 1053 97.08 1057.39 94.69 1059.79 90.3 1062.19 94.69"
              fill="#8af1eb"
            />
            <use
              transform="translate(1017 54)"
              xlinkHref="#a986ed6f-0b40-453e-a94c-dec2035ef9ff"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="1249.35 103.67 1255.94 107.27 1249.35 110.86 1245.76 117.45 1242.16 110.86 1235.57 107.27 1242.16 103.67 1245.76 97.08 1249.35 103.67"
              fill="#8af1eb"
            />
            <use
              transform="translate(1199 61)"
              xlinkHref="#aeff00c8-713c-4c6e-aa65-8a1c4e61f8a2"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="1553.42 94.16 1560 97.76 1553.42 101.36 1549.82 107.94 1546.22 101.36 1539.64 97.76 1546.22 94.16 1549.82 87.58 1553.42 94.16"
              fill="#8af1eb"
            />
            <use
              transform="translate(1503 51)"
              xlinkHref="#f7707b16-cd19-49ca-ab7b-c4865bdcfa62"
            />
          </g>
          <circle
            cx="1376.07"
            cy="38.71"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="1407.29"
            cy="80.8"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="1290.55"
            cy="114.73"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="1156.16"
            cy="107.94"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
        </g>
        <g opacity="0.51">
          <circle cx="211" cy="403" r="211" fill="#ff866e" />
          <path
            d="M310.18,508c-53.89,18.76-97.11-56-121.93-88.4s-62.75,2.76-112.4,15.17c-49.48,12.37-75-46.49-73.69-61.89a211.8,211.8,0,0,0,.7,64.86c20.4,15.47,55.73,34.63,97.12,24.61,65.51-15.86,105.5,22.07,136.53,63.44,16.73,22.3,62.93,36.79,101.95,45.41a211.21,211.21,0,0,0,76-112.15C413.87,459.36,363.75,489.31,310.18,508Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M332.78,546.72c-62.85,21.88-113.25-65.3-142.2-103.1s-73.18,3.22-131.08,17.7C37,467,18.67,459.91,4.86,448.16a209.37,209.37,0,0,0,13.44,40.9c20.09,7.24,43.72,10.62,69.34,4.42,76.4-18.49,123,25.73,159.23,74,9,12,25.43,22.13,44.95,30.49a211.53,211.53,0,0,0,89.85-70.89C366.39,534,349.74,540.82,332.78,546.72Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M347.26,495.7C284.41,517.57,234,430.39,205.06,392.6S131.88,395.81,74,410.29c-34.1,8.52-58.43-12-72.32-33.84A213.48,213.48,0,0,0,0,403c0,6.46.31,12.84.87,19.15,24.47,15.65,60.32,30.22,101.25,20.31,76.4-18.5,123,25.73,159.23,74,15.27,20.36,51.61,35.14,88.51,45.42a211.21,211.21,0,0,0,61.62-92.94A642,642,0,0,1,347.26,495.7Z"
            fill="#8cdff2"
            opacity="0.28"
          />
          <path
            d="M233.38,612.82c-30.47-24.09-55.25-64-72.46-86.45-25.65-33.5-63.32-5.09-111.86,11.88a212,212,0,0,0,35.78,33.9c41.66-2.39,73.44,15.25,99.53,40.18A212.73,212.73,0,0,0,211,614,214.93,214.93,0,0,0,233.38,612.82Z"
            fill="#8cdff2"
            opacity="0.28"
          />
          <path
            d="M403.72,317c-31.77,24.66-82.91,54.68-103.08,20.5-24.82-42.06-51-45.51-101.36-53.78S144.8,311.29,97.23,312c-24.1.35-37.93-24.94-41-52.4a211.57,211.57,0,0,0-23.69,30.77c2.78,19.54,9.32,38.58,23.28,48.52,35.86,25.52,84.82-21.37,134.46-22.75s71,48.27,105.5,86.88c22.94,25.69,83.41,12.31,126-8.66A210,210,0,0,0,403.72,317Z"
            fill="#f7c99a"
            opacity="0.35"
          />
          <path
            d="M419.22,368.74c-33.8,17.91-72.76,29.42-90.66,3.23-28.75-42.06-59.1-45.51-117.4-53.78S148.07,345.77,93,346.46c-27.9.35-43.92-24.94-47.45-52.41a218.77,218.77,0,0,0-27.43,30.78c3.22,19.54,10.79,38.58,27,48.52,41.53,25.51,98.23-21.38,155.73-22.76S283,398.86,323,437.48c18.13,17.53,56.52,16.86,94.75,8a212.75,212.75,0,0,0,1.5-76.74Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M421.86,395.77a210.09,210.09,0,0,0-14.62-70.45c-32.54,14.89-67.39,22.12-84.26-1.62-29.9-42.06-61.45-45.51-122.07-53.78S135.32,297.5,78,298.19c-16.43.2-28.89-7.83-37.28-19.82a211.18,211.18,0,0,0-22.53,38.77,46.82,46.82,0,0,0,10,7.94c43.18,25.51,102.13-21.37,161.92-22.75s85.53,48.26,127,86.88C337,407.66,380.13,406,421.86,395.77Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M340,236a211.29,211.29,0,0,0-178.81-38.06c-8.91,10-3.72,18.65,24.34,32.67C223.86,249.8,301.1,250.1,340,236Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M244.43,194.65A210.94,210.94,0,0,1,353.74,379.56c0,116.53-94.47,211-211,211a212.91,212.91,0,0,1-33.43-2.65A210.06,210.06,0,0,0,211,614c116.53,0,211-94.47,211-211C422,297.84,345.07,210.67,244.43,194.65Z"
            fill="#422151"
            opacity="0.34"
          />
        </g>
        <path
          d="M101,782.07C101,730,273,730,299,703s169-54,217-52.5S814.52,652,755.34,652L933,650l-832,1Z"
          fill="#334c23"
        />
        <path
          d="M920.86,677,902,691s-101-12-125,8-42,53-65,48-115,5-164,37S303,830,299,891s75,53,75,53l23,3c9,11,70,19,92,30l12,23c-30-18-111-26.17-166-37-63.5-12.5-54.5-81.5-54.5-81.5,3-33-56-31-56-31l25-8c20.37,7.41,48.11-.67,52.12-1.92C337.43,814.3,420.65,799.81,437,790c20-12,64-13,123-45s133-18,142-21-8-13-8-13l11-8a67,67,0,0,0,24,7c13,1,10-7,48-25S920.86,677,920.86,677Z"
          fill="#415c93"
        />
        <path
          d="M492.5,986.5s-94-25-141-32-74-39-58-79,112-66,181-82,108-52,157-56,81,1,96-8,30-27,44-35,41-18,82-14,59,2.52,59,2.52"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1252,733.43,1213,746c-14-6.35-69.38-1.22-107.53-8.45-24-4.56-20.5-17.84-44.5-36.81s-73-12.91-73-12.91l13.39-16.24S1024,670.38,1069,684c20.84,6.32,26,15.41,28.66,23.06-.16-.91-.25-1.51-.27-1.7.85,3.68,14.25,14.84,30.93,15.33,1,0,1.77.07,2.41.13h0C1171.14,721.58,1252,733.43,1252,733.43Z"
          fill="#415c93"
        />
        <path
          d="M1228.74,739.82c-16.26-5.7-34.54-6.09-66.74-8.73-30-2.46-52.25,7.63-69.5-18.59-13.28-20.19-27.5-20.87-52.5-28.46s-45.67-5.31-45.67-5.31-36.46-13.11-86.65-2.19"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeWidth="0.87"
          strokeDasharray="10.45"
        />
        <g>
          <path
            d="M1243.82,791c8.67-14.32,11.62-17.58,7.94-27.22s-7.23-1.41-3.54-19.56-10.35-23.53-16.73-24.24-36.57,17-31.47,26.65,7.28,37,1.8,39.26S1233.61,807.91,1243.82,791Z"
            fill="#396039"
          />
          <path
            d="M1238,757.73c-.28-7.8,11.48-10.92,7.65-14.46s-8.36-12.76-12.05-7.94-6.52,11.91-9.35,7.94-6-4.11-7.8,0-.28,9.21-4.68,7.94-6.37.71-5.81,5,3.83,2.55,6.66,7.65,15.6,4.4,13.47,1.56S1238,757.73,1238,757.73Z"
            fill="#447244"
          />
          <path
            d="M1260,744.26c6.38-10.06,15.31-19.28,24.24-10.63s-6,24.1,0,30.19,4.68,21.55,0,22.12-26.93.56-32.74,3.26S1238.15,782,1238,772.33,1260,744.26,1260,744.26Z"
            fill="#6b996b"
          />
          <path
            d="M1226.39,803.94c14.93,11.38,16-28.21,0-24.81s-21.27,2.41-26.37-4.68-17.86,5.39-18.29,8.94,3.69,15.45,12.48,18.85S1217.45,797.14,1226.39,803.94Z"
            fill="#447244"
          />
          <path
            d="M1257.25,811.88c-14.94,11.38-16-28.21,0-24.81s21.26,2.41,26.36-4.68,17.86,5.39,18.29,8.93-3.69,15.45-12.48,18.86S1266.18,805.07,1257.25,811.88Z"
            fill="#447244"
          />
          <path
            d="M1275.86,798.27c2.12-4.25,8.36,4,8.36,4s-.42-5.53,3-7.51,5,3.11,5,3.11c.28-4,8.36-.28,6.1,4.44h0a18.94,18.94,0,0,1-8.84,7.9,15.6,15.6,0,0,1-6.32.81l-7.62-1.94S1273.73,802.52,1275.86,798.27Z"
            fill="#396039"
          />
          <path
            d="M1245.1,805.5c-3,5.24-4.68,52.45,0,74.14,0,0-13.61-2.41-17.86-.15-.43,1.42-.43.15-.43.15s18.85-65.64,2.41-84.91-34.3,0-34.3,0,4.82-11.34,15.45-12.2,25.23,12.9,25.94,15.6c0,0,.56-20.7-6.1-27.93s1.85-12.47,1.85-12.47-8.79,2.69,5.38,21.12c7.35,9.55,2.13,27.36,2.13,27.36s4.53-13.89,15.87-10.92,18.15,16.16,28.78,15.31c0,0-12.47-.71-22.4-6.66S1245.1,805.5,1245.1,805.5Z"
            fill="#704d3c"
          />
          <path
            d="M1260.61,803.27a13,13,0,0,0-15.51,2.23c-1,1.81-1.9,8.59-2.42,17.6-3.4-11.75,2.7-25.68,4.63-26.93a10.7,10.7,0,0,1,8.13-.88,24.89,24.89,0,0,1,7.48,3.56Z"
            fill="#634b42"
          />
          <path
            d="M1234.54,798.91c1.56,3.54,3.26,13.93,1.34,19.3h0c-.36-9.73-2.23-18.29-6.66-23.48a31.94,31.94,0,0,0-3-3.05c-.4-1.22-.66-2-.66-2C1228,791,1233,795.36,1234.54,798.91Z"
            fill="#44322c"
          />
          <path
            d="M1257.46,801.07c4.11-1.33,4.37-7.09,9.23-6.76s5.44,7.34,9.48,11.88,7.34,3.54,10.56,5.11-8.82,18.88-20,12.61-10.14-5.19-14-7.75S1248.31,804,1257.46,801.07Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1236.19,792.18c.08.25.08.28,0,.13v-.13Z" fill="#7f2c03" />
            <path
              d="M1236,789.67c-.53-6.58-2-15.28-5.82-19.47a8.52,8.52,0,0,1-2.53-5.12l2-.38c.69,3.15,2.84,7.68,7.81,14.15l.33.44C1237.42,783,1236.26,786.85,1236,789.67Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1220.67,789.16c-2.69-3.38.27-8.32-4-10.73s-8.59,3.11-14.46,4.66-8.08-1.09-11.63-1.56-3.06,20.61,9.75,21.58,11.32,1.27,16,1.27S1226.67,796.69,1220.67,789.16Z"
            fill="#6b996b"
          />
          <path
            d="M1226.08,749.37c2.79-4.4,6.7-8.43,10.6-4.65s-2.6,10.55,0,13.21,2,9.43,0,9.68-11.78.25-14.33,1.43-5.83-3.17-5.89-7.39S1226.08,749.37,1226.08,749.37Z"
            fill="#6b996b"
          />
          <path
            d="M1198.17,798.4c.8,1.22,3.16,1,4.53.44s2.15-4.74,4.36-4,3.27,2.91,5.73,2.2,1.38-3.34,4.52-3.39c2.9,0,5.83,1.14,5.93,2.76,0,.14,0,.27,0,.4h0a2.18,2.18,0,0,0,0,.38c-.57,4.15-3.91,7.21-6.84,7.2-4.64,0-3.16-.31-16-1.27a10.36,10.36,0,0,1-4.72-1.5C1194.24,800.68,1197.36,797.18,1198.17,798.4Z"
            fill="#447244"
          />
          <path
            d="M1255.73,816.13c3.12,0,9.35,3.4,10.2.28s7.09-3.82,7.8-2.41,4.54,3.26,6.66,2.13,4.26,1.7,3.29,2.82c-4,4.46-10.6,8.53-17,5-7.78-4.34-9.64-5.16-11.35-6.1C1254.61,817.27,1253.34,816.13,1255.73,816.13Z"
            fill="#396039"
          />
          <path
            d="M1244.1,780.27c2-4.4,6.81-3.55,10.21-3s2.41,5.1,5.1,3,8.65,3,6.4,6.66h0c-6,.42-11.78,1.08-14.33,2.27-3.6,1.66-7.85-1.51-10.6-6.45l-1.2-2.5h0S1242.12,784.66,1244.1,780.27Z"
            fill="#447244"
          />
          <path
            d="M1280.11,777.57c-1.28-4,4.39-7.37,0-7.37s-11.62,4.4-10.91-2-1.28-9.78-6.1-9.36-8.5-9.92-5.81-12.26-15,4.46-7.23,11.13,10.63,4.53,10.35,7.65,0,9.64,5.95,10.63-1.69,9.08,2.77,10.92S1283.51,788.2,1280.11,777.57Z"
            fill="#447244"
          />
          <path
            d="M1226.81,879.64s1.17-4.07,2.67-10.48c11.84-6.08,12.69-25.85,12.71-26.44.06,13.44.89,27.56,2.91,36.92,0,0-13.61-2.41-17.86-.15C1226.81,880.91,1226.81,879.64,1226.81,879.64Z"
            fill="#44322c"
          />
          <path
            d="M1240.94,879c.08-3.83-1.25-7.46-1.74-11.25a75.11,75.11,0,0,1-.23-11.42c.15-3.81.54-7.59.8-11.37s.55-7.58.75-11.36c.1-1.89.2-3.79.23-5.68a21,21,0,0,0-.1-2.77c-.15-.86-.47-1.82-.67-2.73a35,35,0,0,1-1-5.67,11.53,11.53,0,0,1,.77-5.76c.86-1.71,1.68-3.42,2.67-5.07a13.19,13.19,0,0,1,3.79-4.32,9.52,9.52,0,0,1,5.55-1.33,24.9,24.9,0,0,1,5.64.79,25,25,0,0,0-5.64-.58,9.19,9.19,0,0,0-5.32,1.46,12.91,12.91,0,0,0-3.56,4.26c-.93,1.63-1.72,3.36-2.54,5.07a7.85,7.85,0,0,0-.63,2.64,15.19,15.19,0,0,0,0,2.78,34.06,34.06,0,0,0,1,5.54c.21.93.51,1.79.7,2.79a22.18,22.18,0,0,1,.13,2.91c0,1.91-.1,3.81-.2,5.71-.43,7.59-1.19,15.17-1.74,22.72a75.44,75.44,0,0,0,0,11.35C1240,871.49,1241.16,875.21,1240.94,879Z"
            fill="#44322c"
          />
          <path
            d="M1237.94,842.71a36.69,36.69,0,0,0,0,4.69,7.08,7.08,0,0,1-.28,2.4,6.8,6.8,0,0,1-1.25,2.09c-.25.31-.56.61-.78.9a6,6,0,0,0-.69.88,11.2,11.2,0,0,0-1,2,16.51,16.51,0,0,0-1,4.45,19,19,0,0,0,0,4.58,14.63,14.63,0,0,0,.51,2.22c.24.71.52,1.5.7,2.26a37.53,37.53,0,0,1,1,9.37c-.15-1.56-.34-3.11-.61-4.65a36.39,36.39,0,0,0-1-4.54c-.23-.75-.5-1.43-.77-2.2a14.52,14.52,0,0,1-.57-2.34,19.62,19.62,0,0,1-.13-4.78,17.93,17.93,0,0,1,1.13-4.66,11,11,0,0,1,1.15-2.13,12,12,0,0,1,1.58-1.79,6.15,6.15,0,0,0,1.23-1.86,6.47,6.47,0,0,0,.37-2.22A28.38,28.38,0,0,1,1237.94,842.71Z"
            fill="#44322c"
          />
          <path
            d="M1237.94,782.46c.12.9.3,1.77.5,2.65a12.51,12.51,0,0,1,.46,2.69,5.83,5.83,0,0,1-.14,1.38c0,.23-.13.46-.17.67a2.91,2.91,0,0,0-.06.6A10.68,10.68,0,0,0,1239,793c1,3.4,2,7,1.54,10.74a18.54,18.54,0,0,1-.6,2.7l-.33,1.27-.23,1.3a36.13,36.13,0,0,0-.27,5.31,53.23,53.23,0,0,0,.38,5.35c.2,1.78.48,3.55.82,5.32a47.92,47.92,0,0,1-1.85-10.64,29.24,29.24,0,0,1,.15-5.45l.22-1.35.33-1.34a19.6,19.6,0,0,0,.54-2.57,17.78,17.78,0,0,0-.12-5.25c-.28-1.75-.79-3.46-1.21-5.22a10.66,10.66,0,0,1-.41-2.73,3.21,3.21,0,0,1,.1-.74c.06-.23.14-.41.19-.63a5.59,5.59,0,0,0,.2-1.28,12.59,12.59,0,0,0-.27-2.64A20.27,20.27,0,0,1,1237.94,782.46Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M153.43,476.28h31.08a14.07,14.07,0,0,1,14.07,14.07V644.25a14.07,14.07,0,0,1-14.07,14.07H159.37a14.07,14.07,0,0,1-14.07-14.07V484.4A8.13,8.13,0,0,1,153.43,476.28Z"
            fill="#8161a3"
          />
          <rect
            x="326.6"
            y="532.52"
            width="25.9"
            height="114.7"
            fill="#8161a3"
          />
          <rect
            x="448.7"
            y="579.14"
            width="25.9"
            height="65.86"
            fill="#8161a3"
          />
          <path
            d="M151.36,476.28h4.08a.89.89,0,0,1,.89.89V652.81a5.51,5.51,0,0,1-5.51,5.51h0a5.51,5.51,0,0,1-5.51-5.51V482.34a6.06,6.06,0,0,1,6.06-6.06Z"
            fill="#e9847e"
            opacity="0.46"
          />
          <path
            d="M145.3,658.32l.37-176.12a5.73,5.73,0,0,1,5.18-5.55"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <line
            x1="145.3"
            y1="476.28"
            x2="156.32"
            y2="476.28"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect
            x="165.38"
            y="483.68"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="178.37"
            y="496.26"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="165.51"
            y="507.36"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="161.07"
            y="522.16"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="182.81"
            y="511.06"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="176.53"
            y="528.08"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="161.07"
            y="539.18"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="178.37"
            y="544.36"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="178.37"
            y="548.8"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="164.72"
            y="563.6"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="164.72"
            y="574.7"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <rect
            x="178.37"
            y="585.06"
            width="9.19"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="2.33"
            opacity="0.46"
          />
          <g>
            <polygon
              points="243.33 512.25 240.3 660.54 248.26 660.54 243.33 512.25"
              fill="#6d4c89"
            />
            <circle cx="244.09" cy="572.17" r="15.17" fill="#6d4c89" />
          </g>
          <rect
            x="262.22"
            y="500.7"
            width="29.6"
            height="182.04"
            fill="#7c5aa0"
          />
          <rect
            x="331.99"
            y="536.96"
            width="2.54"
            height="110.04"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect
            x="262.22"
            y="500.7"
            width="4.44"
            height="182.04"
            fill="#7ac1b3"
            opacity="0.46"
          />
          <line
            x1="262.22"
            y1="655.36"
            x2="262.22"
            y2="500.7"
            fill="none"
            stroke="#48edcd"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="311.06"
            y="495.52"
            width="21.46"
            height="182.04"
            fill="#6d4c89"
          />
          <rect
            x="311.06"
            y="495.52"
            width="4.44"
            height="182.04"
            fill="#e9847e"
            opacity="0.46"
          />
          <line
            x1="311.06"
            y1="677.56"
            x2="311.06"
            y2="495.52"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <line
            x1="311.06"
            y1="495.52"
            x2="315.5"
            y2="495.52"
            fill="#e9847e"
            opacity="0.46"
          />
          <path
            d="M195.4,522.89h7.38a10.59,10.59,0,0,1,10.6,10.59v111.3a10.6,10.6,0,0,1-10.18,10.59l-7.64.3a10.6,10.6,0,0,1-11-10.62l.25-111.59A10.61,10.61,0,0,1,195.4,522.89Z"
            fill="#6d4c89"
          />
          <polygon
            points="488.59 582.84 504.81 582.84 521.9 613.61 516.92 616.83 523.66 625.33 523.66 656.1 488.59 656.1 488.59 582.84"
            fill="#937fad"
          />
          <polygon
            points="504.81 582.84 498.65 582.84 521.9 613.61 504.81 582.84"
            fill="#4e3668"
          />
          <polygon
            points="516.92 616.83 511.94 619.47 523.66 625.33 516.92 616.83"
            fill="#4e3668"
          />
          <g opacity="0.42">
            <polygon
              points="480.35 462.39 482.74 463.7 480.35 465.01 479.04 467.4 477.73 465.01 475.34 463.7 477.73 462.39 479.04 460 480.35 462.39"
              fill="#8af1eb"
            />
            <image
              width="80"
              height="80"
              transform="translate(439 424)"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAAAsSAAALEgHS3X78AAADoElEQVR4Xu3az04bVxSA8e/cO/4HxqYBhQQlbUN3ZMm6Ul6CvkIfI87r4JeIlDXKKiy7qBBgpRCMTOyxfe/pwiBFkVqkHqUzkc5P8sLSeBbfXN97ZzSiqrj/Ljx0gPt3HtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjYqHDqiKgHz5XaGW7+FJ3d4PFJAByD7ICW8FYJ9XegI6AK1byLoFlCGEE4icnxcUxWqKWS4zT58u9yEdQqZGEWsT8M1qPg49aJTjP9ux2Grl+U0TIDR787S8LFv9H2c3sADy61XIytVlDhQgrI9Grdm6rol0+mE57VMUawBhOf2cpDOeTS7G67fy+XZnp2Q1Ciu/+pWPQAE5gnDKaXM2KbqUutWIjScp8ASlf3fQOGYuFmlxQUsu293l5BnP5r9BrnpOrHwEDkBOIPavu61C5j1i2NEoP0eVn1R0C0CQS43aLmgoKS/kurs42SQNajAKK90HCsgHkB6ncbxYtJNKD9HHovoc9IWI7onoHugLUX2O6OOk0hsvFu0ep/EDyNfbnf9bpQEBXvJWEo3QibEIIbZCCGsoGwg9oA/0EXooGyGEtRBiqxNjkWiEl3fbnCpVHnCfVzoaAe2cYZ416EJFypy1VJWZqsxy1lJFSg26gHmmnfNotPrtQ+f/1ioPOGRId2eaYmrNU2CiSa+UPEI4g7z6CGdKHmnSqxSYxNSad3emacjwodN/c5UuIqsV9DD/znH6peyWeb0xTss8KlQaGiQpcgUgcCWZ06XoKDca43Rblmcbl+mIw8o31ZUGhNUKMOAgTbcp25/+mEh7U7RMqoSZRHoAmrhB8sfQin/J7Hoy3d4rd9lOQsX1qEFABRXgENKvP+QZoNNbyUl0Jpo7AJrCNKrcdDaZ0MnlMaRhTe6LK58DYRXxCPI73i+veDTrqt7QbH6MDc5jg3OazY9d1ZsrHs3e8X55VIMN9L3K70S+dP8k5uz4OO5ubUVardUFLst8dnmZdg8O0qAmI+9erQLCKqICb+4eaQGcgL6++6vXKR7UMOC97+WBauWLyD+pa7Cv1WIR+Z55QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc0+hs6F3VfRi2sggAAAABJRU5ErkJggg=="
            />
          </g>
          <g opacity="0.15">
            <polygon
              points="441.13 494.21 443.52 495.52 441.13 496.83 439.82 499.22 438.51 496.83 436.12 495.52 438.51 494.21 439.82 491.82 441.13 494.21"
              fill="#8af1eb"
            />
            <image
              width="80"
              height="81"
              transform="translate(400 455)"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAAAsSAAALEgHS3X78AAADgElEQVR4Xu3aT27bVhDH8d+8R1KURDqybNi10rgBWgOB050v0EWvkFwhx4hznfgKXfgCQlbpplkUrREhNSLDsmiKf95MF46LrhqgU5QsOt8lwQXxAR7f44AkIrD+fu5zN1h/nQEqM0BlBqjMAJUZoDIDVGaAygxQmQEqM0BlBqjMAJUZoDIDVGaAygxQmQEqM0BlBqjMAJUZoDIDVGaAygxQmQEqM0BlBqjMAJUZoDIDVBZ97oZ/OyIiEcErgO6vvQSEAAjQu58ZqU8/WBJApwDh/Nxhb89NjxP66R3w7fU1/3Bywq8BRs8QewN4j3cA+MViEadpGife+xVWGNZpU+6uG+BxC4Bf3kH2ot68A0/v8S4vB+PcZd656YaavZzSXfF+O7nZGR8AyXvM/asePXdf3oH0HnOPy8PBaISMJJ4y1zsR+XGDID5yK6puliu6vToqviyKfVS4W8qdL5/OAQmg14CbLWbxOOcRSTxFwENE7iEJJg4kEPmINElZAD8aMIDwHJAzgLveWDpfCqcA/Qj4BwfDpGW3FVreZ/BXYBwJ4QlATwRy5IUOqZW9Jg7ZFMvke8B1KvepTgEJoLcAbeHCN0WTIkJOkdt1hBkRHhH4EMChiDxi5gOJaJtaHi9vqqQC3J+POl3VKSAAPMU5BcROKh/JRlK0YSyEDIRMgAyEMRGNQDQkcoPQhnhMzi3xc+d4QA8Aj/GdfPgAIGX2EQdyVEuQSkRKEbkFUJDQLURKEa585JtCmKd43IcV3D3gGc6Q7ZfBh0EdWqzJu4/iZAHBBYh+AeNXlnDhnFtQK1cSuWKaD+rB3Xmwc8ROd+G7HfQZv8A8fF1lFVN7zY1PyJEnSMWgB0QuQHgZSC4Q0W9x49fLdFK/BfgFuhfsFBC42wVOcRLKXVTA8mZUCupNG6J4sAY3Y0bL3kcr3myWLvVXUtyWyPO2L591nQPKp0HBMyB88W5ZDb+ZSMrUlm1dxM4noRIJnkoe5MUky8t5Nm9m2O8FHtADQOCPKQs/f/Om3amfyuR4O2yQbtzK+3WywnArbWpcNwvk7QwnvfoW7s0wAbBpzD+SzQP/Z3V+DvyvZ4DKDFCZASozQGUGqMwAlRmgMgNUZoDKDFCZASozQGUGqMwAlRmgMgNUZoDKDFCZASozQGUGqMwAlRmgMgNUZoDKDFCZASozQGUGqMwAlf0OhRNmUwAe8gQAAAAASUVORK5CYII="
            />
          </g>
          <rect
            x="112"
            y="522.16"
            width="43.66"
            height="139.12"
            rx="13"
            fill="#6d4c89"
          />
          <rect
            x="123.84"
            y="568.04"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="131.98"
            y="550.28"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="138.64"
            y="535.48"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="120.14"
            y="536.22"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="138.64"
            y="568.78"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="139.38"
            y="584.32"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="120.14"
            y="591.72"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <g>
            <polygon
              points="218.8 575.84 218.8 612.88 218.8 668.43 202.76 659.17 202.76 603.62 218.8 575.84"
              fill="#7c57a3"
            />
            <polygon
              points="218.8 575.84 218.8 612.88 202.76 603.62 218.8 575.84"
              fill="#e9847e"
              opacity="0.46"
            />
            <polygon
              points="234.11 603.19 218.8 575.84 218.8 612.88 218.8 668.43 234.84 658.67 234.11 603.19"
              fill="#6d4c89"
            />
          </g>
          <g>
            <ellipse
              cx="158.22"
              cy="688.81"
              rx="30.75"
              ry="8.73"
              fill="#d0827d"
            />
            <ellipse
              cx="158.22"
              cy="686.36"
              rx="30.75"
              ry="8.73"
              fill="#6d4c89"
            />
            <ellipse
              cx="158.22"
              cy="686.36"
              rx="30.75"
              ry="8.73"
              fill="#6d4c89"
            />
            <path
              d="M154.55,591c-19,0-34.41,22.13-34.41,49.44s15.41,49.43,34.41,49.43S189,667.72,189,640.42,173.56,591,154.55,591Zm0,78.8c-11.28,0-20.43-13.15-20.43-29.36s9.15-29.36,20.43-29.36S175,624.2,175,640.42,165.84,669.78,154.55,669.78Z"
              fill="#663f6d"
            />
            <g>
              <path
                d="M157.17,611.3a15.11,15.11,0,0,0-2.62-.24c-11.28,0-20.43,13.14-20.43,29.36s9.15,29.36,20.43,29.36a14.19,14.19,0,0,0,2.62-.25c-10-1.85-17.81-14.17-17.81-29.11S147.12,613.15,157.17,611.3Z"
                fill="#563e70"
              />
              <path
                d="M159.79,591a25.4,25.4,0,0,0-2.62.14C175,593,189,614.38,189,640.42s-14,47.37-31.8,49.29a22.88,22.88,0,0,0,2.62.14c19,0,34.42-22.13,34.42-49.43S178.8,591,159.79,591Z"
                fill="#563e70"
              />
            </g>
            <g>
              <path
                d="M156.48,669.65a15.22,15.22,0,0,0,1.92.13c11.29,0,20.44-13.15,20.44-29.36s-9.15-29.36-20.44-29.36a13.56,13.56,0,0,0-1.92.13c10.38,1.39,18.51,13.94,18.51,29.23S166.86,668.25,156.48,669.65Z"
                fill="#d0827d"
              />
              <path
                d="M124,640.42c0-26.38,14.38-47.93,32.5-49.36-.64,0-1.28-.08-1.93-.08-19,0-34.41,22.13-34.41,49.44s15.41,49.43,34.41,49.43c.65,0,1.29,0,1.93-.07C138.36,688.34,124,666.79,124,640.42Z"
                fill="#d0827d"
              />
            </g>
            <rect
              x="171.5"
              y="610.68"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="136.21"
              y="610.68"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="134.46"
              y="612.43"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="132.02"
              y="614.18"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="128.87"
              y="627.11"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="128.87"
              y="638.64"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="141.1"
              y="606.14"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="155.43"
              y="594.96"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="155.08"
              y="597.41"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="161.72"
              y="599.85"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="165.56"
              y="604.75"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="174.64"
              y="612.08"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="179.18"
              y="634.79"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="173.59"
              y="669.38"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="178.84"
              y="625.71"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
            <rect
              x="176.39"
              y="617.67"
              width="3.84"
              height="0.77"
              fill="#c6bb7b"
            />
          </g>
          <g>
            <ellipse
              cx="242.66"
              cy="688.99"
              rx="17.76"
              ry="4.07"
              fill="#5a3e77"
            />
            <ellipse
              cx="242.29"
              cy="687.14"
              rx="17.76"
              ry="4.07"
              fill="#6d4c89"
            />
            <circle cx="240.44" cy="663.46" r="25.16" fill="#663f6d" />
            <path
              d="M222.68,666.42a25.14,25.14,0,0,1,30.69-24.54A25.16,25.16,0,1,0,234.91,688,25.14,25.14,0,0,1,222.68,666.42Z"
              fill="#d0827d"
            />
            <path
              d="M224.67,643.87a36.06,36.06,0,0,0,7.75,2.13,41.94,41.94,0,0,0,8,.61,44.59,44.59,0,0,0,8-.78,64.79,64.79,0,0,0,7.82-2c-1.25.5-2.5,1-3.78,1.46s-2.59.81-3.92,1.06c-.67.15-1.33.29-2,.41l-2,.27a19.62,19.62,0,0,1-2,.18c-.68,0-1.36.11-2,.1a38.72,38.72,0,0,1-8.11-.79A28.13,28.13,0,0,1,224.67,643.87Z"
              fill="#a285c1"
            />
            <path
              d="M238.59,688.25c.65.13,1.28.26,1.91.37a25.16,25.16,0,0,0,19.86-40.53h0S268.19,684.55,238.59,688.25Z"
              fill="#5a3e77"
            />
            <path
              d="M218.61,651a57.18,57.18,0,0,0,10.65,3.7,47.6,47.6,0,0,0,11.12,1.47,34.8,34.8,0,0,0,5.59-.29,34.36,34.36,0,0,0,5.49-1.16,29.59,29.59,0,0,0,5.22-2,35.06,35.06,0,0,0,4.87-2.86,30.63,30.63,0,0,1-9.92,5.45,29.65,29.65,0,0,1-5.56,1.27,35.14,35.14,0,0,1-5.7.37,45.4,45.4,0,0,1-11.25-1.66A46.59,46.59,0,0,1,218.61,651Z"
              fill="#a285c1"
            />
            <path
              d="M215.63,659.29a44,44,0,0,0,11.94,4.92,48.39,48.39,0,0,0,12.78,1.63,12.4,12.4,0,0,0,1.61,0l1.61-.09,1.61-.09c.54,0,1.07-.14,1.6-.21L250,665l3.15-.74,1.58-.36c.52-.14,1-.33,1.54-.49l3.08-1c2-.72,4-1.66,6-2.45l-2.93,1.43-1.47.71a11,11,0,0,1-1.49.65l-3.07,1.12c-.51.18-1,.38-1.54.54l-1.58.41c-1.05.28-2.11.56-3.17.81l-3.23.51c-.54.07-1.08.19-1.62.23l-1.63.11-1.64.1a11.1,11.1,0,0,1-1.63,0l-3.28-.1-3.25-.36a44.94,44.94,0,0,1-6.4-1.35,48,48,0,0,1-6.14-2.24A35.42,35.42,0,0,1,215.63,659.29Z"
              fill="#a285c1"
            />
            <path
              d="M215.83,668.71a27,27,0,0,0,5.5,3.35l1.47.67c.49.21,1,.38,1.51.57a27.13,27.13,0,0,0,3.06,1,43,43,0,0,0,12.73,1.36l3.21-.2c1.07-.1,2.12-.31,3.19-.46,2.14-.24,4.19-.92,6.29-1.37a10.51,10.51,0,0,0,1.55-.44l1.53-.51,3.07-1,6-2.44c-1.94.94-3.9,1.86-5.87,2.78L256,673.09l-1.52.56a12.12,12.12,0,0,1-1.55.49l-3.15.84a24.67,24.67,0,0,1-3.19.64c-1.08.16-2.14.39-3.22.5l-3.26.24a41.71,41.71,0,0,1-12.91-1.55A29.54,29.54,0,0,1,215.83,668.71Z"
              fill="#a285c1"
            />
            <path
              d="M220.74,679.11a36.33,36.33,0,0,0,9.51,3.38,43.1,43.1,0,0,0,10,1c.84,0,1.68-.07,2.52-.1l1.26-.06,1.25-.16,2.5-.34,2.48-.51,1.23-.25,1.22-.34,2.43-.7c1.62-.5,3.18-1.15,4.79-1.69-1.54.69-3.08,1.42-4.67,2l-2.42.8-1.21.4-1.24.3-2.49.59-2.54.37-1.26.19-1.28.08c-.85,0-1.7.14-2.56.13a40.71,40.71,0,0,1-10.14-1.2A31.06,31.06,0,0,1,220.74,679.11Z"
              fill="#a285c1"
            />
          </g>
          <rect
            x="326.6"
            y="498.48"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="324.38"
            y="515.5"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="319.2"
            y="526.6"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="319.2"
            y="541.4"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="324.38"
            y="529.56"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="323.64"
            y="547.32"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="337.7"
            y="539.92"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="345.84"
            y="551.02"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="345.84"
            y="545.1"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="340.66"
            y="564.34"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="344.36"
            y="567.3"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="344.36"
            y="610.96"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="339.92"
            y="599.86"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="319.2"
            y="558.42"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="324.38"
            y="563.6"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="324.38"
            y="568.04"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="424.86"
            y="543.7"
            width="21.46"
            height="122.1"
            fill="#937fad"
          />
          <rect
            x="424.86"
            y="543.7"
            width="4.44"
            height="122.3"
            fill="#e9847e"
            opacity="0.46"
          />
          <line
            x1="424.86"
            y1="666"
            x2="424.86"
            y2="543.7"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.21"
            opacity="0.46"
          />
          <line
            x1="424.86"
            y1="543.7"
            x2="429.3"
            y2="543.7"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect
            x="440.4"
            y="546.11"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="438.18"
            y="559.94"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="433"
            y="568.97"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="433"
            y="581"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="438.18"
            y="571.37"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="437.44"
            y="585.81"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="433"
            y="594.84"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="405.78"
            y="621.17"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="408.74"
            y="606.37"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="438.18"
            y="602.66"
            width="3.7"
            height="0.6"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.33"
            opacity="0.46"
          />
          <rect
            x="322.16"
            y="583.58"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="279.24"
            y="578.4"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="282.2"
            y="590.98"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="268.88"
            y="561.38"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="282.2"
            y="555.46"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="270.36"
            y="539.92"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="197.1"
            y="574.7"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="191.18"
            y="588.76"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="196.36"
            y="598.38"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="200.8"
            y="560.64"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="192.66"
            y="544.36"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="199.32"
            y="535.48"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="282.94"
            y="525.12"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="279.24"
            y="514.76"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="273.32"
            y="507.36"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="468.22"
            y="552.94"
            width="20.78"
            height="92.06"
            fill="#7b6996"
          />
          <rect
            x="468.22"
            y="552.94"
            width="3.12"
            height="92.06"
            fill="#7ac1b3"
            opacity="0.46"
          />
          <line
            x1="468.22"
            y1="631.15"
            x2="468.22"
            y2="552.94"
            fill="none"
            stroke="#48edcd"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.46"
          />
          <rect
            x="482.25"
            y="580.64"
            width="2.6"
            height="0.37"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.46"
          />
          <rect
            x="473.93"
            y="572.78"
            width="2.6"
            height="0.37"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.46"
          />
          <rect
            x="482.77"
            y="565.29"
            width="2.6"
            height="0.37"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.46"
          />
          <rect
            x="480.17"
            y="560.05"
            width="2.6"
            height="0.37"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.46"
          />
          <rect
            x="476.01"
            y="556.31"
            width="2.6"
            height="0.37"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="0.88"
            opacity="0.46"
          />
          <rect
            x="322.16"
            y="594.68"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <rect
            x="324.38"
            y="604.3"
            width="3.7"
            height="0.74"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.48"
            opacity="0.46"
          />
          <g>
            <g>
              <polygon
                points="358.5 610.56 379.21 581.37 379.21 646.42 358.06 658.39 358.5 610.56"
                fill="#4d3768"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <polygon
                points="352.98 607.38 379.21 581.37 358.5 610.56 358.06 658.39 352.98 655.2 352.98 607.38"
                fill="#81b5b4"
              />
              <line
                x1="368.63"
                y1="628.63"
                x2="379.21"
                y2="622.34"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <line
                x1="361.64"
                y1="636.32"
                x2="379.21"
                y2="625.83"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <line
                x1="367.69"
                y1="605.15"
                x2="379.21"
                y2="598.61"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <line
                x1="371.57"
                y1="599.84"
                x2="379.21"
                y2="596.11"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
            </g>
            <g>
              <polygon
                points="407.66 609.58 386.95 580.39 386.95 645.44 408.1 657.41 407.66 609.58"
                fill="#4d3768"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <polygon
                points="413.18 606.39 386.95 580.39 407.66 609.58 408.1 657.41 413.18 654.22 413.18 606.39"
                fill="#6a9e9e"
              />
              <line
                x1="397.52"
                y1="627.64"
                x2="386.95"
                y2="621.35"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <line
                x1="404.52"
                y1="635.34"
                x2="386.95"
                y2="624.85"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <line
                x1="398.47"
                y1="604.16"
                x2="386.95"
                y2="597.62"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
              <line
                x1="394.58"
                y1="598.86"
                x2="386.95"
                y2="595.13"
                fill="#5f467a"
                stroke="#72bdc1"
                strokeMiterlimit="10"
                strokeWidth="0.42"
              />
            </g>
            <polygon
              points="381.53 581.37 368.63 616.44 379.21 616.7 381.53 581.37"
              fill="#81b5b4"
            />
            <polygon
              points="383.73 581.37 386.97 616.7 396.88 616.44 383.73 581.37"
              fill="#81b5b4"
            />
            <polygon
              points="368.63 616.44 368.63 664.79 379.21 664.52 379.21 616.7 368.63 616.44"
              fill="#6a9e9e"
            />
            <polygon
              points="386.97 616.7 386.95 664.79 396.88 664.79 396.88 616.44 386.97 616.7"
              fill="#6a9e9e"
            />
            <polygon
              points="386.95 664.79 383.73 638 383.73 581.37 386.97 616.7 386.95 664.79"
              fill="#4d3768"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.42"
            />
            <polygon
              points="379.21 664.52 381.53 639.26 381.53 581.37 379.21 616.7 379.21 664.52"
              fill="#4d3768"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.42"
            />
          </g>
        </g>
        <g>
          <path
            d="M605.78,560.52h22.05a14.07,14.07,0,0,1,14.07,14.07v123a14.07,14.07,0,0,1-14.07,14.07H611.73a14.07,14.07,0,0,1-14.07-14.07v-129A8.13,8.13,0,0,1,605.78,560.52Z"
            fill="#937fad"
          />
          <rect
            x="748.24"
            y="607.23"
            width="21.51"
            height="95.27"
            fill="#8161a3"
          />
          <path
            d="M602.69,560.52h3.39a.74.74,0,0,1,.74.74V707.14a4.58,4.58,0,0,1-4.58,4.58h0a4.58,4.58,0,0,1-4.58-4.58V565.55A5,5,0,0,1,602.69,560.52Z"
            fill="#e9847e"
            opacity="0.46"
          />
          <path
            d="M597.66,711.72,598,565.44a4.75,4.75,0,0,1,4.3-4.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <line
            x1="597.66"
            y1="560.52"
            x2="606.81"
            y2="560.52"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect
            x="614.34"
            y="566.67"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="625.12"
            y="577.12"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="614.44"
            y="586.34"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="610.76"
            y="598.63"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="628.81"
            y="589.41"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="623.6"
            y="603.54"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="610.76"
            y="612.76"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="625.12"
            y="617.07"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="625.12"
            y="620.75"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="613.79"
            y="633.05"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="613.79"
            y="642.27"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <rect
            x="625.12"
            y="650.87"
            width="7.63"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.94"
            opacity="0.46"
          />
          <g>
            <polygon
              points="679.08 590.4 676.56 713.56 683.17 713.56 679.08 590.4"
              fill="#6d4c89"
            />
            <circle cx="679.71" cy="640.17" r="12.6" fill="#6d4c89" />
          </g>
          <rect
            x="694.77"
            y="580.8"
            width="24.58"
            height="151.2"
            fill="#7c5aa0"
          />
          <rect
            x="752.72"
            y="610.92"
            width="2.11"
            height="91.4"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect
            x="694.77"
            y="580.8"
            width="3.69"
            height="151.2"
            fill="#7ac1b3"
            opacity="0.46"
          />
          <line
            x1="694.77"
            y1="709.26"
            x2="694.77"
            y2="580.8"
            fill="none"
            stroke="#48edcd"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="735.33"
            y="576.5"
            width="17.82"
            height="151.2"
            fill="#6d4c89"
          />
          <rect
            x="735.33"
            y="576.5"
            width="3.69"
            height="151.2"
            fill="#e9847e"
            opacity="0.46"
          />
          <line
            x1="735.33"
            y1="727.7"
            x2="735.33"
            y2="576.5"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <line
            x1="735.33"
            y1="576.5"
            x2="739.02"
            y2="576.5"
            fill="#e9847e"
            opacity="0.46"
          />
          <path
            d="M639.27,599.23h6.13a8.8,8.8,0,0,1,8.8,8.8v92.44a8.8,8.8,0,0,1-8.45,8.8l-6.35.24a8.8,8.8,0,0,1-9.15-8.81l.22-92.69A8.8,8.8,0,0,1,639.27,599.23Z"
            fill="#7b6996"
          />
          <rect
            x="570"
            y="598.63"
            width="36.26"
            height="115.55"
            rx="13"
            fill="#847099"
          />
          <rect
            x="579.83"
            y="636.73"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="586.59"
            y="621.98"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="592.13"
            y="609.69"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="576.76"
            y="610.31"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="592.13"
            y="637.35"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="592.74"
            y="650.26"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="576.76"
            y="656.4"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <g>
            <polygon
              points="658.71 643.21 658.71 673.97 658.71 720.12 645.39 712.43 645.39 666.28 658.71 643.21"
              fill="#7c57a3"
            />
            <polygon
              points="658.71 643.21 658.71 673.97 645.39 666.28 658.71 643.21"
              fill="#e9847e"
              opacity="0.46"
            />
            <polygon
              points="671.42 665.93 658.71 643.21 658.71 673.97 658.71 720.12 672.03 712.01 671.42 665.93"
              fill="#6d4c89"
            />
          </g>
          <rect
            x="748.24"
            y="578.96"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="746.4"
            y="593.1"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="742.09"
            y="602.32"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="742.09"
            y="614.61"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="746.4"
            y="604.77"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="745.78"
            y="619.52"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="757.46"
            y="613.38"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="764.22"
            y="622.6"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="764.22"
            y="617.68"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="759.92"
            y="633.66"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="762.99"
            y="636.12"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="762.99"
            y="672.38"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="759.3"
            y="663.16"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="742.09"
            y="628.74"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="746.4"
            y="633.05"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="746.4"
            y="636.73"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="744.55"
            y="649.64"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="708.9"
            y="645.34"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="711.36"
            y="655.79"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="700.3"
            y="631.2"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="711.36"
            y="626.29"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="701.53"
            y="613.38"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="640.68"
            y="642.27"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="635.76"
            y="653.94"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="640.07"
            y="661.93"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="643.75"
            y="630.59"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="636.99"
            y="617.07"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="642.52"
            y="609.69"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="711.98"
            y="601.09"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="708.9"
            y="592.48"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="703.99"
            y="586.34"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="744.55"
            y="658.86"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
          <rect
            x="746.4"
            y="666.85"
            width="3.07"
            height="0.61"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.23"
            opacity="0.46"
          />
        </g>
        <g>
          <g>
            <path
              d="M854.11,633.36s5.18,10.77-1.38,16.65h10.18s-3.72-1.83-4.18-3-.51-8.78-3.71-13.29Z"
              fill="#6d4c89"
            />
            <path
              d="M855.41,633.89s.55-6.22,4.1-7c0,0-1.47,1.26-.74,2.28,0,0,1.35-3,5.47-2.28,0,0-4.74.58-5.47,3.45a3.3,3.3,0,0,1,3.64,1.1S855.41,631.54,855.41,633.89Z"
              fill="#6d4c89"
            />
            <path
              d="M854.11,633.89s-.55-6.22-4.1-7c0,0,1.47,1.26.74,2.28,0,0-1.35-3-5.47-2.28,0,0,4.74.58,5.47,3.45a3.3,3.3,0,0,0-3.64,1.1S854.11,631.54,854.11,633.89Z"
              fill="#6d4c89"
            />
            <path
              d="M855.85,635s-6.87-9-14.54-5.51c0,0,4.34-.16,4.7.35,0,0-1.42-.22-1.35,1.17,0,0,3-1.41,3.78-.71,0,0-1.64.33-1.54,1,0,0,2.63-.63,3.31,0,0,0-1.7.4-1,1.21,0,0,2.32-1,3.43.5,0,0-1-.33-1.27,0C851.35,633,855.67,634.07,855.85,635Z"
              fill="#6d4c89"
            />
            <path
              d="M854.58,634.87s5.88-8.47,13.8-4.17c0,0-4.3-.6-4.61-.12a1.36,1.36,0,0,1,1.46,1.34s-3.06-1.74-3.81-1.11c0,0,1.65.5,1.62,1.2,0,0-2.66-.91-3.26-.36,0,0,1.71.58,1.13,1.35,0,0-2.4-1.27-3.35.16,0,0,.93-.24,1.26.16C858.82,633.32,854.65,634,854.58,634.87Z"
              fill="#6d4c89"
            />
            <path
              d="M856,634.5s-6.52-5.19-11.81,1.87c0,0,3.26-2.29,3.61-2a1.58,1.58,0,0,0-.85,1.79s2-2.8,2.75-2.54c0,0-1.19,1.12-1,1.73,0,0,1.9-1.89,2.5-1.64,0,0-1.23,1.22-.6,1.66,0,0,1.61-2.1,2.68-1.21,0,0-.78.16-1,.65C852.31,634.83,855.74,633.71,856,634.5Z"
              fill="#6d4c89"
            />
            <path
              d="M854.11,634.68s7.75-6,13.83,1.86c0,0-3.78-2.5-4.2-2.15a1.7,1.7,0,0,1,1,2s-2.32-3.11-3.18-2.8c0,0,1.37,1.23,1.15,1.92,0,0-2.18-2.09-2.9-1.79,0,0,1.42,1.34.67,1.85,0,0-1.85-2.33-3.12-1.3,0,0,.92.16,1.11.71C858.43,635,854.43,633.78,854.11,634.68Z"
              fill="#6d4c89"
            />
            <path
              d="M855.24,634.86c-.28-3.59,3.51-7.78,6.23-7.51,0,0-5.38-1.05-6.25,2.17,0,0,1.09-4.27,2.68-4.27,0,0-3.51-1-4.14,2,0,0-1.9-3.71,0-4.21,0,0-4.34,1.16-2.49,4,0,0-2-1.65-4.33.53,0,0,4.62.08,5.4,1.91,0,0-2-1.3-3.22,0,0,0,4.07-.67,5.1,2.34Z"
              fill="#6d4c89"
            />
            <path
              d="M855,634.86c-.22-2.77,2.71-6,4.81-5.79,0,0-4.16-.81-4.83,1.68,0,0,.84-3.3,2.07-3.3,0,0-2.71-.74-3.19,1.55,0,0-1.47-2.86,0-3.25,0,0-3.35.9-1.92,3.11a2.48,2.48,0,0,0-3.34.41s3.56.06,4.16,1.48c0,0-1.56-1-2.48,0,0,0,3.14-.52,3.93,1.79Z"
              fill="#6d4c89"
            />
            <path
              d="M854.67,636s.32-3.59,2.37-4.06c0,0-.85.73-.43,1.32a2.73,2.73,0,0,1,3.16-1.32s-2.74.34-3.16,2a1.94,1.94,0,0,1,2.11.64S854.67,634.6,854.67,636Z"
              fill="#6d4c89"
            />
            <path
              d="M855.28,635.44s-.31-3.6-2.37-4.06c0,0,.86.73.43,1.32a2.73,2.73,0,0,0-3.16-1.32s2.74.33,3.16,2a1.91,1.91,0,0,0-2.1.64S855.29,634.08,855.28,635.44Z"
              fill="#6d4c89"
            />
            <path
              d="M858.73,647c-.41-1.06-.5-7.33-2.84-11.86.31,1.25,2.42,9.79,1.33,12.23-.43,1,1,1.89,2.93,2.64h2.76S859.19,648.18,858.73,647Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
          <rect x="911.85" y="582" width="5.69" height="69.24" fill="#6d4c89" />
          <rect x="911.85" y="582" width="1.23" height="69.24" fill="#e59661" />
          <rect
            x="1009.88"
            y="582"
            width="1.23"
            height="69.24"
            fill="#e59661"
          />
          <rect
            x="960.25"
            y="603.44"
            width="1.23"
            height="11.03"
            fill="#e59661"
          />
          <rect
            x="1011.11"
            y="582"
            width="5.69"
            height="69.24"
            fill="#6d4c89"
          />
          <rect
            x="900.21"
            y="614.47"
            width="113.96"
            height="9.19"
            fill="#6d4c89"
          />
          <path
            d="M917.36,582a51.89,51.89,0,0,0,8.8,11.21,50.37,50.37,0,0,0,11.18,8.31,54,54,0,0,0,26.62,6.2,61.28,61.28,0,0,0,13.7-1.67,58.41,58.41,0,0,0,6.58-2.08,54.25,54.25,0,0,0,17.62-11.11,57.93,57.93,0,0,0,9.25-10.86,44,44,0,0,1-7.51,12.52,52.77,52.77,0,0,1-5.16,5.31,50.71,50.71,0,0,1-19.59,10.71A57.83,57.83,0,0,1,964,612.62c-10,.16-20.22-2.31-28.63-7.83a45.57,45.57,0,0,1-11-10A40.86,40.86,0,0,1,917.36,582Z"
            fill="#6d4c89"
          />
          <line
            x1="963.32"
            y1="603.44"
            x2="963.32"
            y2="618.76"
            fill="none"
            stroke="#6d4c89"
            strokeMiterlimit="10"
            strokeWidth="4.9"
          />
          <polygon
            points="1014.17 623.66 1051.75 647.56 1014.17 614.47 1014.17 623.66"
            fill="#6d4c89"
          />
          <polygon
            points="900.21 623.66 862.63 647.56 900.21 614.47 900.21 623.66"
            fill="#6d4c89"
          />
          <g>
            <polygon
              points="822.93 593.83 838.85 599.52 854.77 605.2 854.87 650.65 838.9 656.36 822.84 650.65 822.93 593.83"
              fill="#663f6d"
            />
            <polygon
              points="854.7 593.8 854.77 605.2 838.85 599.52 854.7 593.8"
              fill="#663f6d"
            />
            <polygon
              points="838.85 610.89 854.77 605.2 838.85 599.52 822.84 605.17 838.85 610.89"
              fill="none"
              stroke="#e59661"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <polygon
              points="822.84 616.61 838.85 610.89 854.87 616.61 838.81 622.28 822.84 616.61"
              fill="none"
              stroke="#e59661"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <polygon
              points="822.84 627.98 838.81 622.28 854.78 627.94 838.81 633.65 822.84 627.98"
              fill="none"
              stroke="#e59661"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <polygon
              points="854.77 639.32 838.85 645 822.84 639.35 838.81 633.65 854.77 639.32"
              fill="none"
              stroke="#e59661"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <polygon
              points="822.84 650.65 838.85 645 854.87 650.65 838.9 656.36 822.84 650.65"
              fill="none"
              stroke="#e59661"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <line
              x1="838.85"
              y1="599.52"
              x2="838.9"
              y2="656.36"
              fill="none"
              stroke="#e59661"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <polygon
              points="822.93 593.83 838.81 588.13 854.7 593.8 838.85 599.52 822.93 593.83"
              fill="#e59661"
            />
          </g>
          <g>
            <path
              d="M808.15,635.2s5.19,10.76-1.37,16.65H817s-3.73-1.83-4.19-3-.5-8.78-3.7-13.29Z"
              fill="#6d4c89"
            />
            <path
              d="M809.46,635.73s.55-6.22,4.1-7c0,0-1.48,1.27-.74,2.29,0,0,1.35-3,5.47-2.29,0,0-4.75.58-5.47,3.45a3.32,3.32,0,0,1,3.64,1.11S809.45,633.38,809.46,635.73Z"
              fill="#6d4c89"
            />
            <path
              d="M808.15,635.73s-.54-6.22-4.1-7c0,0,1.48,1.27.74,2.29,0,0-1.35-3-5.47-2.29,0,0,4.75.58,5.47,3.45a3.32,3.32,0,0,0-3.64,1.11S808.16,633.38,808.15,635.73Z"
              fill="#6d4c89"
            />
            <path
              d="M809.89,636.83s-6.87-9-14.53-5.51c0,0,4.33-.16,4.7.35,0,0-1.42-.23-1.35,1.17,0,0,2.95-1.41,3.78-.71,0,0-1.64.33-1.54,1,0,0,2.63-.63,3.3,0,0,0-1.69.4-1,1.21,0,0,2.32-1,3.44.5,0,0-1-.33-1.27,0C805.4,634.87,809.72,635.91,809.89,636.83Z"
              fill="#6d4c89"
            />
            <path
              d="M808.62,636.7s5.88-8.46,13.81-4.16c0,0-4.3-.6-4.61-.12a1.35,1.35,0,0,1,1.45,1.34s-3-1.74-3.8-1.11c0,0,1.65.5,1.62,1.19,0,0-2.66-.9-3.27-.35,0,0,1.72.58,1.13,1.35,0,0-2.39-1.27-3.34.16,0,0,.92-.24,1.26.15C812.87,635.15,808.7,635.78,808.62,636.7Z"
              fill="#6d4c89"
            />
            <path
              d="M810.05,636.34s-6.52-5.19-11.81,1.87c0,0,3.25-2.29,3.6-2A1.58,1.58,0,0,0,801,638s2-2.8,2.75-2.54c0,0-1.19,1.12-1,1.73,0,0,1.89-1.89,2.49-1.64,0,0-1.22,1.21-.59,1.66,0,0,1.61-2.1,2.68-1.21,0,0-.79.16-1,.65C806.36,636.67,809.78,635.55,810.05,636.34Z"
              fill="#6d4c89"
            />
            <path
              d="M808.15,636.52s7.76-6,13.83,1.86c0,0-3.77-2.51-4.19-2.15a1.69,1.69,0,0,1,1,2s-2.32-3.1-3.19-2.8c0,0,1.38,1.24,1.16,1.93,0,0-2.19-2.09-2.9-1.79,0,0,1.41,1.34.66,1.85,0,0-1.84-2.33-3.11-1.31,0,0,.91.17,1.11.71C812.48,636.81,808.48,635.62,808.15,636.52Z"
              fill="#6d4c89"
            />
            <path
              d="M809.29,636.7c-.29-3.59,3.51-7.78,6.23-7.52,0,0-5.38-1-6.25,2.18,0,0,1.09-4.27,2.68-4.27,0,0-3.51-1-4.14,2,0,0-1.9-3.71,0-4.21,0,0-4.34,1.16-2.49,4,0,0-2-1.65-4.34.52,0,0,4.62.09,5.41,1.92,0,0-2-1.3-3.23,0,0,0,4.08-.67,5.1,2.33Z"
              fill="#6d4c89"
            />
            <path
              d="M809.07,636.7c-.22-2.77,2.7-6,4.8-5.8,0,0-4.15-.8-4.82,1.68,0,0,.84-3.29,2.07-3.29,0,0-2.71-.74-3.2,1.55,0,0-1.46-2.86,0-3.25,0,0-3.34.89-1.91,3.11a2.48,2.48,0,0,0-3.35.41s3.57.06,4.17,1.47c0,0-1.56-1-2.49,0,0,0,3.15-.52,3.94,1.8Z"
              fill="#6d4c89"
            />
            <path
              d="M808.72,637.8s.31-3.6,2.37-4.06c0,0-.86.73-.43,1.32a2.73,2.73,0,0,1,3.16-1.32s-2.74.33-3.16,2a1.91,1.91,0,0,1,2.1.64S808.71,636.44,808.72,637.8Z"
              fill="#6d4c89"
            />
            <path
              d="M809.33,637.27s-.32-3.59-2.37-4c0,0,.85.72.43,1.32a2.72,2.72,0,0,0-3.16-1.32s2.74.33,3.16,2a1.9,1.9,0,0,0-2.1.64S809.33,635.92,809.33,637.27Z"
              fill="#6d4c89"
            />
            <path
              d="M812.77,648.84c-.41-1.06-.49-7.33-2.84-11.86.32,1.25,2.43,9.79,1.34,12.23-.43,1,1,1.88,2.93,2.64H817S813.23,650,812.77,648.84Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
          <g>
            <path
              d="M872.09,624.65s8,16.33-1.87,25.38l15.5-.14s-5.7-2.73-6.41-4.52-.89-13.37-5.83-20.2Z"
              fill="#6d4c89"
            />
            <path
              d="M874.08,625.44s.76-9.47,6.15-10.75c0,0-2.23,1.94-1.09,3.49,0,0,2-4.66,8.3-3.55,0,0-7.22,1-8.28,5.33a5,5,0,0,1,5.55,1.63S874,621.86,874.08,625.44Z"
              fill="#6d4c89"
            />
            <path
              d="M872.1,625.46s-.92-9.46-6.34-10.64c0,0,2.26,1.9,1.15,3.47,0,0-2.09-4.63-8.35-3.41,0,0,7.23.82,8.37,5.18a5,5,0,0,0-5.53,1.73S872.07,621.88,872.1,625.46Z"
              fill="#6d4c89"
            />
            <path
              d="M874.76,627.11s-10.58-13.54-22.2-8.2c0,0,6.59-.3,7.15.47,0,0-2.16-.32-2,1.81,0,0,4.47-2.19,5.74-1.14,0,0-2.49.52-2.33,1.57,0,0,4-1,5-.07,0,0-2.58.63-1.54,1.86,0,0,3.53-1.56,5.24.72,0,0-1.48-.49-1.93,0C867.89,624.18,874.48,625.72,874.76,627.11Z"
              fill="#6d4c89"
            />
            <path
              d="M872.82,626.94s8.85-13,21-6.52c0,0-6.55-.87-7-.12a2.06,2.06,0,0,1,2.23,2s-4.67-2.62-5.81-1.65c0,0,2.52.74,2.49,1.8,0,0-4.06-1.34-5-.49,0,0,2.62.86,1.74,2,0,0-3.67-1.89-5.09.29,0,0,1.4-.37,1.91.22C879.26,624.52,872.93,625.54,872.82,626.94Z"
              fill="#6d4c89"
            />
            <path
              d="M875,626.37s-10-7.82-18,3c0,0,4.93-3.52,5.46-3.05a2.39,2.39,0,0,0-1.26,2.73s3-4.29,4.16-3.9c0,0-1.8,1.72-1.52,2.65,0,0,2.86-2.9,3.78-2.53,0,0-1.85,1.86-.88,2.53,0,0,2.42-3.22,4.05-1.87,0,0-1.19.25-1.45,1C869.37,626.92,874.57,625.16,875,626.37Z"
              fill="#6d4c89"
            />
            <path
              d="M872.1,626.66s11.74-9.2,21.09,2.66c0,0-5.79-3.77-6.42-3.22a2.59,2.59,0,0,1,1.49,3s-3.57-4.7-4.88-4.22c0,0,2.11,1.86,1.78,2.92,0,0-3.36-3.16-4.44-2.7,0,0,2.17,2,1,2.82,0,0-2.85-3.53-4.77-2,0,0,1.4.24,1.71,1.07C878.7,627.06,872.59,625.29,872.1,626.66Z"
              fill="#6d4c89"
            />
            <path
              d="M873.83,626.93c-.47-5.47,5.25-11.9,9.4-11.53,0,0-8.21-1.53-9.5,3.4,0,0,1.6-6.52,4-6.54,0,0-5.36-1.42-6.28,3.11,0,0-2.94-5.62-.06-6.41,0,0-6.59,1.82-3.73,6.17,0,0-3-2.49-6.6.86,0,0,7,.07,8.26,2.85,0,0-3.1-2-4.91,0,0,0,6.2-1.08,7.8,3.48Z"
              fill="#6d4c89"
            />
            <path
              d="M873.5,626.93c-.37-4.22,4-9.17,7.24-8.89,0,0-6.33-1.18-7.32,2.62,0,0,1.23-5,3.1-5,0,0-4.13-1.09-4.84,2.39,0,0-2.27-4.33,0-4.94,0,0-5.09,1.4-2.88,4.76,0,0-2.35-1.92-5.09.66,0,0,5.43.06,6.37,2.2,0,0-2.39-1.52-3.79,0,0,0,4.78-.83,6,2.69Z"
              fill="#6d4c89"
            />
            <path
              d="M873,628.6s.44-5.47,3.56-6.21c0,0-1.29,1.12-.64,2,0,0,1.17-2.69,4.8-2,0,0-4.17.54-4.79,3.07a2.92,2.92,0,0,1,3.21,1S873,626.54,873,628.6Z"
              fill="#6d4c89"
            />
            <path
              d="M873.91,627.8s-.53-5.47-3.66-6.15c0,0,1.31,1.1.66,2,0,0-1.21-2.68-4.83-2,0,0,4.19.48,4.84,3a2.91,2.91,0,0,0-3.19,1S873.89,625.73,873.91,627.8Z"
              fill="#6d4c89"
            />
            <path
              d="M879.31,645.37c-.65-1.61-.85-11.16-4.49-18,.5,1.9,3.83,14.88,2.2,18.61-.65,1.49,1.51,2.86,4.5,4l4.2,0S880,647.16,879.31,645.37Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
          <g>
            <path
              d="M1064.41,642.84s-2.47,5,.58,7.8l-4.77,0s1.76-.84,2-1.39.27-4.11,1.79-6.21Z"
              fill="#6d4c89"
            />
            <path
              d="M1063.8,643.08s-.23-2.91-1.89-3.31c0,0,.69.6.34,1.08a2.22,2.22,0,0,0-2.56-1.1s2.23.3,2.55,1.64a1.55,1.55,0,0,0-1.71.51S1063.81,642,1063.8,643.08Z"
              fill="#6d4c89"
            />
            <path
              d="M1064.41,643.08s.28-2.9,1.95-3.27c0,0-.7.59-.35,1.07a2.21,2.21,0,0,1,2.57-1s-2.23.25-2.58,1.6a1.54,1.54,0,0,1,1.7.53S1064.42,642,1064.41,643.08Z"
              fill="#6d4c89"
            />
            <path
              d="M1063.59,643.59s3.26-4.16,6.83-2.52c0,0-2-.09-2.2.15,0,0,.67-.1.63.55,0,0-1.38-.67-1.77-.35,0,0,.77.16.72.49,0,0-1.23-.31-1.55,0,0,0,.79.2.47.58,0,0-1.08-.49-1.61.22,0,0,.46-.15.6,0C1065.71,642.69,1063.68,643.16,1063.59,643.59Z"
              fill="#6d4c89"
            />
            <path
              d="M1064.19,643.54s-2.72-4-6.45-2c0,0,2-.27,2.16,0a.63.63,0,0,0-.69.62s1.44-.81,1.79-.51c0,0-.77.23-.76.56,0,0,1.24-.42,1.53-.15,0,0-.81.26-.54.62,0,0,1.13-.58,1.57.09,0,0-.43-.12-.59.07C1062.21,642.8,1064.16,643.11,1064.19,643.54Z"
              fill="#6d4c89"
            />
            <path
              d="M1063.52,643.36a3.78,3.78,0,0,1,5.53.93s-1.52-1.09-1.68-.94a.74.74,0,0,1,.39.84s-.94-1.32-1.28-1.2c0,0,.55.53.46.81,0,0-.88-.89-1.16-.78,0,0,.57.58.27.78,0,0-.74-1-1.25-.57,0,0,.37.08.45.3C1065.25,643.53,1063.65,643,1063.52,643.36Z"
              fill="#6d4c89"
            />
            <path
              d="M1064.41,643.45s-3.61-2.82-6.48.82c0,0,1.77-1.16,2-1a.8.8,0,0,0-.46.93s1.1-1.44,1.5-1.3c0,0-.65.57-.55.9,0,0,1-1,1.37-.83,0,0-.67.62-.32.87,0,0,.88-1.09,1.47-.6,0,0-.43.07-.53.33C1062.38,643.58,1064.26,643,1064.41,643.45Z"
              fill="#6d4c89"
            />
            <path
              d="M1063.88,643.54c.15-1.69-1.61-3.66-2.89-3.55,0,0,2.52-.47,2.92,1,0,0-.49-2-1.24-2,0,0,1.65-.43,1.93,1,0,0,.91-1.73,0-2,0,0,2,.56,1.15,1.9a1.5,1.5,0,0,1,2,.26s-2.17,0-2.54.88c0,0,1-.61,1.51,0,0,0-1.91-.33-2.4,1.07Z"
              fill="#6d4c89"
            />
            <path
              d="M1064,643.54c.12-1.3-1.24-2.82-2.23-2.74,0,0,2-.36,2.26.81,0,0-.38-1.55-1-1.55,0,0,1.27-.34,1.49.74,0,0,.7-1.34,0-1.52,0,0,1.57.43.89,1.46a1.16,1.16,0,0,1,1.56.2s-1.67,0-2,.68c0,0,.73-.47,1.16,0,0,0-1.47-.26-1.85.82Z"
              fill="#6d4c89"
            />
            <path
              d="M1064.14,644.05s-.13-1.68-1.09-1.91c0,0,.39.35.19.62a1.27,1.27,0,0,0-1.47-.63s1.28.17,1.47,1a.9.9,0,0,0-1,.29S1064.15,643.42,1064.14,644.05Z"
              fill="#6d4c89"
            />
            <path
              d="M1063.86,643.8s.16-1.68,1.12-1.89c0,0-.4.34-.2.62a1.28,1.28,0,0,1,1.48-.61s-1.28.15-1.49.93a.91.91,0,0,1,1,.3S1063.86,643.17,1063.86,643.8Z"
              fill="#6d4c89"
            />
            <path
              d="M1062.2,649.21c.19-.5.26-3.43,1.37-5.55-.15.59-1.17,4.58-.67,5.73.2.46-.47.88-1.38,1.22h-1.3S1062,649.76,1062.2,649.21Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
          <g>
            <path
              d="M814.84,627.24s-5.3,13.93,1.4,21.55H805.85s3.81-2.37,4.27-3.9.52-11.36,3.79-17.2Z"
              fill="#6d4c89"
            />
            <path
              d="M813.51,627.92s-.56-8-4.19-9.09c0,0,1.51,1.64.76,3a4.69,4.69,0,0,0-5.59-3s4.85.76,5.59,4.47c0,0-2.09-1-3.72,1.43C806.36,624.73,813.51,624.88,813.51,627.92Z"
              fill="#6d4c89"
            />
            <path
              d="M814.84,627.92s.56-8,4.19-9.09c0,0-1.51,1.64-.75,3a4.68,4.68,0,0,1,5.58-3s-4.85.76-5.58,4.47c0,0,2.09-1,3.71,1.43C822,624.73,814.84,624.88,814.84,627.92Z"
              fill="#6d4c89"
            />
            <path
              d="M813.07,629.34s7-11.58,14.84-7.12c0,0-4.43-.21-4.8.45,0,0,1.45-.29,1.38,1.52,0,0-3-1.83-3.86-.92,0,0,1.67.42,1.57,1.31,0,0-2.68-.81-3.37,0,0,0,1.73.52,1,1.57,0,0-2.37-1.3-3.51.65,0,0,1-.43,1.3,0C817.66,626.81,813.24,628.16,813.07,629.34Z"
              fill="#6d4c89"
            />
            <path
              d="M814.36,629.19s-6-11-14.1-5.39c0,0,4.39-.78,4.71-.16,0,0-1.41-.1-1.48,1.74,0,0,3.12-2.26,3.88-1.44,0,0-1.68.64-1.65,1.55,0,0,2.71-1.18,3.33-.46,0,0-1.75.75-1.15,1.74,0,0,2.45-1.64,3.41.21,0,0-.94-.31-1.28.2C810,627.18,814.28,628,814.36,629.19Z"
              fill="#6d4c89"
            />
            <path
              d="M812.91,628.71s6.65-6.71,12.06,2.42c0,0-3.33-3-3.68-2.55a2.14,2.14,0,0,1,.86,2.31s-2.06-3.62-2.81-3.28c0,0,1.21,1.44,1,2.23,0,0-1.93-2.44-2.55-2.12,0,0,1.25,1.57.61,2.15,0,0-1.64-2.72-2.73-1.56,0,0,.8.2,1,.83C816.68,629.14,813.18,627.69,812.91,628.71Z"
              fill="#6d4c89"
            />
            <path
              d="M814.84,628.94s-7.92-7.73-14.12,2.42c0,0,3.86-3.25,4.28-2.79a2.33,2.33,0,0,0-1,2.58s2.37-4,3.25-3.62c0,0-1.4,1.59-1.18,2.49,0,0,2.24-2.7,3-2.32,0,0-1.45,1.74-.68,2.4,0,0,1.88-3,3.18-1.69,0,0-.94.21-1.13.92C810.43,629.33,814.51,627.78,814.84,628.94Z"
              fill="#6d4c89"
            />
            <path
              d="M813.68,629.19c.29-4.66-3.58-10.07-6.36-9.73,0,0,5.5-1.36,6.39,2.82,0,0-1.12-5.53-2.74-5.53,0,0,3.58-1.24,4.23,2.59,0,0,1.93-4.79,0-5.44,0,0,4.43,1.49,2.54,5.22,0,0,2-2.15,4.42.67,0,0-4.71.12-5.52,2.49,0,0,2.07-1.7,3.3,0,0,0-4.16-.88-5.21,3Z"
              fill="#6d4c89"
            />
            <path
              d="M813.91,629.19c.22-3.59-2.76-7.77-4.91-7.51,0,0,4.24-1,4.93,2.18,0,0-.86-4.27-2.11-4.27a2.38,2.38,0,0,1,3.26,2s1.49-3.69,0-4.19c0,0,3.41,1.15,1.95,4,0,0,1.57-1.65,3.42.52,0,0-3.64.09-4.26,1.92,0,0,1.6-1.31,2.54,0,0,0-3.21-.68-4,2.32Z"
              fill="#6d4c89"
            />
            <path
              d="M814.27,630.6s-.33-4.65-2.42-5.25c0,0,.87.94.43,1.71a2.7,2.7,0,0,0-3.23-1.71s2.81.43,3.23,2.58a1.68,1.68,0,0,0-2.14.83S814.27,628.84,814.27,630.6Z"
              fill="#6d4c89"
            />
            <path
              d="M813.64,629.92s.32-4.64,2.42-5.25c0,0-.87,1-.44,1.71a2.71,2.71,0,0,1,3.23-1.71s-2.8.44-3.23,2.58a1.7,1.7,0,0,1,2.15.83S813.64,628.17,813.64,629.92Z"
              fill="#6d4c89"
            />
            <path
              d="M810.12,644.89c.42-1.37.51-9.48,2.91-15.35-.33,1.62-2.48,12.67-1.37,15.83.44,1.27-1,2.44-3,3.42h-2.82S809.66,646.42,810.12,644.89Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
          <g>
            <path
              d="M898.78,631.53s-5.29,13.93,1.41,21.54h-10.4s3.81-2.36,4.27-3.89.52-11.36,3.79-17.2Z"
              fill="#6d4c89"
            />
            <path
              d="M897.45,632.21s-.56-8-4.19-9.09c0,0,1.51,1.64.76,3a4.69,4.69,0,0,0-5.59-3s4.85.75,5.59,4.47c0,0-2.09-1-3.72,1.43C890.3,629,897.46,629.17,897.45,632.21Z"
              fill="#6d4c89"
            />
            <path
              d="M898.78,632.21s.56-8,4.19-9.09c0,0-1.51,1.64-.75,3a4.69,4.69,0,0,1,5.58-3s-4.85.75-5.58,4.47c0,0,2.09-1,3.71,1.43C905.93,629,898.78,629.17,898.78,632.21Z"
              fill="#6d4c89"
            />
            <path
              d="M897,633.63s7-11.58,14.84-7.12c0,0-4.43-.21-4.8.45,0,0,1.45-.29,1.38,1.52,0,0-3-1.83-3.86-.92,0,0,1.67.42,1.57,1.31,0,0-2.68-.81-3.37,0,0,0,1.73.51,1,1.57,0,0-2.37-1.3-3.51.64,0,0,1-.42,1.3,0C901.6,631.1,897.18,632.45,897,633.63Z"
              fill="#6d4c89"
            />
            <path
              d="M898.31,633.48s-6-11-14.11-5.39c0,0,4.4-.78,4.71-.16,0,0-1.41-.1-1.48,1.74,0,0,3.12-2.26,3.88-1.44,0,0-1.68.64-1.65,1.55,0,0,2.71-1.18,3.33-.46,0,0-1.75.75-1.15,1.74,0,0,2.45-1.64,3.42.21,0,0-1-.31-1.29.2C894,631.47,898.23,632.28,898.31,633.48Z"
              fill="#6d4c89"
            />
            <path
              d="M896.85,633s6.66-6.71,12.06,2.42c0,0-3.32-3-3.68-2.56a2.16,2.16,0,0,1,.86,2.32s-2.06-3.62-2.81-3.29c0,0,1.22,1.45,1,2.24,0,0-1.94-2.44-2.55-2.12,0,0,1.25,1.57.6,2.15,0,0-1.64-2.72-2.73-1.57,0,0,.8.21,1,.84C900.62,633.43,897.12,632,896.85,633Z"
              fill="#6d4c89"
            />
            <path
              d="M898.79,633.23s-7.93-7.73-14.13,2.41c0,0,3.86-3.24,4.29-2.78a2.31,2.31,0,0,0-1,2.58s2.36-4,3.25-3.62c0,0-1.41,1.59-1.18,2.49,0,0,2.23-2.7,3-2.32,0,0-1.45,1.73-.68,2.4,0,0,1.89-3,3.18-1.69,0,0-.93.21-1.13.92C894.37,633.62,898.45,632.07,898.79,633.23Z"
              fill="#6d4c89"
            />
            <path
              d="M897.63,633.47c.29-4.65-3.59-10.06-6.37-9.73,0,0,5.5-1.35,6.39,2.82,0,0-1.11-5.52-2.74-5.52,0,0,3.58-1.24,4.23,2.59,0,0,1.94-4.79,0-5.44,0,0,4.43,1.49,2.54,5.22,0,0,2-2.15,4.43.67,0,0-4.72.12-5.52,2.48,0,0,2.07-1.69,3.29,0,0,0-4.16-.87-5.21,3Z"
              fill="#6d4c89"
            />
            <path
              d="M897.85,633.47c.23-3.58-2.76-7.76-4.91-7.5,0,0,4.24-1,4.93,2.18,0,0-.86-4.27-2.11-4.27a2.38,2.38,0,0,1,3.26,2s1.49-3.69,0-4.19c0,0,3.42,1.15,2,4,0,0,1.56-1.65,3.41.52,0,0-3.64.09-4.25,1.92,0,0,1.59-1.31,2.54,0,0,0-3.21-.68-4,2.32Z"
              fill="#6d4c89"
            />
            <path
              d="M898.21,634.89s-.33-4.65-2.42-5.25c0,0,.87.94.43,1.71a2.7,2.7,0,0,0-3.22-1.71s2.8.43,3.22,2.58a1.69,1.69,0,0,0-2.14.82S898.21,633.13,898.21,634.89Z"
              fill="#6d4c89"
            />
            <path
              d="M897.58,634.21s.33-4.65,2.42-5.25c0,0-.87.94-.43,1.71a2.7,2.7,0,0,1,3.22-1.71s-2.8.44-3.22,2.58a1.68,1.68,0,0,1,2.14.83S897.58,632.46,897.58,634.21Z"
              fill="#6d4c89"
            />
            <path
              d="M894.06,649.18c.43-1.37.51-9.48,2.91-15.35-.33,1.62-2.48,12.67-1.37,15.83.44,1.26-1,2.44-3,3.41h-2.82S893.6,650.71,894.06,649.18Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
          <g>
            <path
              d="M795,631.78s5.29,11-1.41,17h10.4s-3.81-1.87-4.27-3.08-.52-9-3.79-13.57Z"
              fill="#6d4c89"
            />
            <path
              d="M796.28,632.32s.56-6.35,4.19-7.17c0,0-1.51,1.29-.76,2.33,0,0,1.38-3.11,5.59-2.33,0,0-4.85.59-5.59,3.52a3.39,3.39,0,0,1,3.72,1.13S796.27,629.92,796.28,632.32Z"
              fill="#6d4c89"
            />
            <path
              d="M795,632.32s-.56-6.35-4.19-7.17c0,0,1.51,1.29.75,2.33,0,0-1.37-3.11-5.58-2.33,0,0,4.85.59,5.58,3.52a3.37,3.37,0,0,0-3.71,1.13S795,629.92,795,632.32Z"
              fill="#6d4c89"
            />
            <path
              d="M796.72,633.44s-7-9.14-14.84-5.62c0,0,4.43-.17,4.8.35,0,0-1.45-.22-1.38,1.2,0,0,3-1.44,3.86-.72,0,0-1.67.33-1.57,1,0,0,2.68-.64,3.37,0,0,0-1.73.4-1,1.23,0,0,2.37-1,3.51.51,0,0-1-.33-1.3,0C792.13,631.44,796.55,632.51,796.72,633.44Z"
              fill="#6d4c89"
            />
            <path
              d="M795.43,633.32s6-8.65,14.1-4.25c0,0-4.4-.62-4.71-.13a1.38,1.38,0,0,1,1.48,1.37s-3.12-1.78-3.88-1.13c0,0,1.68.51,1.65,1.22,0,0-2.71-.93-3.33-.36,0,0,1.75.59,1.15,1.37,0,0-2.45-1.29-3.42.17,0,0,.95-.25,1.29.15C799.76,631.73,795.51,632.38,795.43,633.32Z"
              fill="#6d4c89"
            />
            <path
              d="M796.88,632.94s-6.66-5.3-12.06,1.91c0,0,3.32-2.33,3.68-2a1.61,1.61,0,0,0-.86,1.83s2.06-2.86,2.81-2.59c0,0-1.22,1.14-1,1.76,0,0,1.94-1.93,2.55-1.67,0,0-1.25,1.24-.6,1.7,0,0,1.64-2.15,2.73-1.24,0,0-.8.17-1,.66C793.11,633.28,796.61,632.14,796.88,632.94Z"
              fill="#6d4c89"
            />
            <path
              d="M794.94,633.13s7.93-6.1,14.13,1.9c0,0-3.86-2.56-4.29-2.2a1.75,1.75,0,0,1,1,2s-2.37-3.17-3.25-2.86c0,0,1.4,1.26,1.18,2,0,0-2.24-2.14-3-1.84,0,0,1.45,1.37.68,1.9,0,0-1.89-2.38-3.18-1.33,0,0,.93.16,1.13.72C799.36,633.43,795.28,632.21,794.94,633.13Z"
              fill="#6d4c89"
            />
            <path
              d="M796.1,633.32c-.28-3.68,3.59-8,6.37-7.68,0,0-5.5-1.07-6.39,2.22,0,0,1.12-4.36,2.74-4.36,0,0-3.58-1-4.23,2,0,0-1.94-3.79,0-4.3,0,0-4.43,1.18-2.54,4.12,0,0-2-1.69-4.43.53,0,0,4.72.09,5.52,2,0,0-2.07-1.33-3.29,0,0,0,4.16-.69,5.21,2.38Z"
              fill="#6d4c89"
            />
            <path
              d="M795.88,633.32c-.22-2.84,2.76-6.13,4.91-5.93,0,0-4.24-.82-4.93,1.72,0,0,.86-3.36,2.11-3.36,0,0-2.76-.76-3.26,1.58,0,0-1.49-2.92,0-3.32,0,0-3.42.91-2,3.18a2.52,2.52,0,0,0-3.41.41s3.64.07,4.26,1.51c0,0-1.6-1-2.55,0,0,0,3.21-.53,4,1.84Z"
              fill="#6d4c89"
            />
            <path
              d="M795.52,634.43s.33-3.67,2.42-4.14c0,0-.87.74-.43,1.35a2.77,2.77,0,0,1,3.22-1.35s-2.8.34-3.22,2a1.94,1.94,0,0,1,2.14.65S795.52,633.05,795.52,634.43Z"
              fill="#6d4c89"
            />
            <path
              d="M796.15,633.9s-.32-3.67-2.42-4.15c0,0,.87.75.43,1.35a2.77,2.77,0,0,0-3.22-1.35s2.8.35,3.22,2a1.94,1.94,0,0,0-2.14.65S796.15,632.51,796.15,633.9Z"
              fill="#6d4c89"
            />
            <path
              d="M799.67,645.71c-.42-1.08-.51-7.48-2.91-12.11.33,1.27,2.48,10,1.37,12.49-.44,1,1,1.92,3,2.7h2.82S800.13,646.92,799.67,645.71Z"
              fill="#6d4c89"
              opacity="0.24"
            />
          </g>
        </g>
        <g>
          <g>
            <polygon
              points="1364.76 664.4 1366.28 583.33 1370.65 583.33 1372.36 666.53 1364.76 666.53 1364.76 664.4"
              fill="#6d4c89"
            />
            <path
              d="M1394.87,559.44c0,3.33-8.12,6.14-19.19,7-4.58,5.07-2.85,12-2.85,12H1364a11,11,0,0,0-2.47-12c-11.12-.85-19.28-3.66-19.28-7,0-4,11.78-7.27,26.31-7.27S1394.87,555.43,1394.87,559.44Z"
              fill="#6d4c89"
            />
            <polygon
              points="1368.39 667.26 1372.36 667.26 1370.74 588.73 1368.68 590.83 1368.39 667.26"
              fill="#6d4c89"
              opacity="0.42"
            />
            <circle cx="1368.75" cy="582.66" r="8.83" fill="#6d4c89" />
            <path
              d="M1369.79,573.89s7.79,13.71-8.06,14.14a8.83,8.83,0,1,0,8.06-14.14Z"
              fill="#6d4c89"
              opacity="0.21"
            />
          </g>
          <ellipse
            cx="1368.56"
            cy="553.79"
            rx="26.21"
            ry="9.69"
            fill="#6d4c89"
          />
        </g>
        <g>
          <g>
            <polygon
              points="1147.57 661.94 1149.02 584.26 1153.21 584.26 1154.85 663.98 1147.57 663.98 1147.57 661.94"
              fill="#6d4c89"
            />
            <path
              d="M1176.41,561.37c0,3.2-7.77,5.89-18.37,6.71-4.39,4.86-2.74,11.54-2.74,11.54h-8.46a10.53,10.53,0,0,0-2.37-11.53c-10.65-.82-18.47-3.51-18.47-6.72,0-3.84,11.29-7,25.21-7S1176.41,557.53,1176.41,561.37Z"
              fill="#6d4c89"
            />
            <polygon
              points="1151.05 664.67 1154.85 664.67 1153.3 589.44 1151.32 591.45 1151.05 664.67"
              fill="#6d4c89"
              opacity="0.42"
            />
            <circle cx="1151.39" cy="583.62" r="8.46" fill="#6d4c89" />
            <path
              d="M1152.39,575.22s7.46,13.14-7.72,13.55a8.46,8.46,0,1,0,7.72-13.55Z"
              fill="#6d4c89"
              opacity="0.21"
            />
          </g>
          <ellipse
            cx="1151.21"
            cy="555.96"
            rx="25.12"
            ry="9.28"
            fill="#6d4c89"
          />
        </g>
        <g>
          <ellipse
            cx="1200.19"
            cy="662.68"
            rx="21.53"
            ry="4.93"
            fill="#5a3e77"
          />
          <ellipse
            cx="1199.74"
            cy="660.44"
            rx="21.53"
            ry="4.93"
            fill="#6d4c89"
          />
          <circle cx="1197.5" cy="631.73" r="30.5" fill="#663f6d" />
          <path
            d="M1176,635.32a30.51,30.51,0,0,1,30.5-30.5,30.87,30.87,0,0,1,6.71.75,30.5,30.5,0,1,0-22.39,55.91A30.47,30.47,0,0,1,1176,635.32Z"
            fill="#d0827d"
          />
          <path
            d="M1178.38,608a43.41,43.41,0,0,0,9.4,2.59,51.51,51.51,0,0,0,9.68.74,54.28,54.28,0,0,0,9.68-.95c1.62-.21,3.18-.68,4.77-1s3.13-.93,4.71-1.35c-1.51.61-3,1.24-4.59,1.77s-3.13,1-4.75,1.29c-.81.18-1.61.36-2.42.5l-2.45.32a22.7,22.7,0,0,1-2.46.22c-.83,0-1.65.14-2.47.13a47.63,47.63,0,0,1-9.83-1,43.65,43.65,0,0,1-4.77-1.3A29.08,29.08,0,0,1,1178.38,608Z"
            fill="#a285c1"
          />
          <path
            d="M1195.26,661.78c.78.17,1.55.31,2.31.45a30.49,30.49,0,0,0,24.07-49.13h0S1231.14,657.3,1195.26,661.78Z"
            fill="#5a3e77"
          />
          <path
            d="M1171,616.57a63.31,63.31,0,0,0,6.35,2.56c2.16.75,4.34,1.4,6.56,1.93a58.52,58.52,0,0,0,13.48,1.78,44,44,0,0,0,6.78-.36c1.13-.12,2.24-.36,3.35-.56s2.21-.5,3.29-.84,2.16-.71,3.23-1.08,2.11-.85,3.11-1.39a43.82,43.82,0,0,0,5.9-3.47,37.58,37.58,0,0,1-18.77,8.15,44.4,44.4,0,0,1-6.91.45,55.53,55.53,0,0,1-13.63-2A56.42,56.42,0,0,1,1171,616.57Z"
            fill="#a285c1"
          />
          <path
            d="M1167.43,626.67a53.24,53.24,0,0,0,14.47,6,58.65,58.65,0,0,0,15.49,2,14.11,14.11,0,0,0,1.95,0l2-.11,2-.1c.65,0,1.29-.18,1.94-.26l3.88-.56,3.81-.89,1.92-.44c.63-.17,1.24-.4,1.87-.59l3.73-1.23a15.08,15.08,0,0,0,1.84-.69l1.81-.77,3.64-1.51-3.54,1.73-1.78.86a13.78,13.78,0,0,1-1.81.79l-3.72,1.35c-.62.22-1.23.48-1.87.66l-1.91.5c-1.28.34-2.56.68-3.84,1l-3.92.61c-.66.09-1.31.23-2,.28l-2,.13-2,.13a16.37,16.37,0,0,1-2,0l-4-.13-4-.43a54.36,54.36,0,0,1-7.76-1.64,59.44,59.44,0,0,1-7.43-2.71A43,43,0,0,1,1167.43,626.67Z"
            fill="#a285c1"
          />
          <path
            d="M1167.67,638.1a33.22,33.22,0,0,0,6.67,4.06l1.78.81c.59.26,1.22.46,1.82.69s1.21.48,1.84.64l1.88.53a51.76,51.76,0,0,0,15.43,1.64l3.89-.24c1.29-.12,2.57-.38,3.86-.56a76.79,76.79,0,0,0,7.63-1.65l1-.23.93-.31,1.86-.61,3.72-1.23,7.27-3q-3.54,1.71-7.11,3.37l-3.7,1.35-1.85.68-.93.34-.95.26-3.81,1c-.65.15-1.27.37-1.92.46l-2,.33c-1.31.19-2.6.47-3.91.6l-4,.29a50.78,50.78,0,0,1-15.65-1.88A35.79,35.79,0,0,1,1167.67,638.1Z"
            fill="#a285c1"
          />
          <path
            d="M1173.62,650.7a44.52,44.52,0,0,0,11.52,4.11,52.71,52.71,0,0,0,12.13,1.23c1,0,2-.08,3.06-.12l1.52-.08,1.52-.2,3-.4c1-.22,2-.42,3-.62l1.5-.3,1.48-.42,2.95-.85c2-.6,3.85-1.39,5.8-2l-2.81,1.26c-1,.39-1.87.88-2.85,1.2l-2.94,1-1.47.48-1.5.37c-1,.25-2,.49-3,.71l-3.07.45-1.54.22-1.55.1c-1,.06-2.06.17-3.1.17a50.47,50.47,0,0,1-12.3-1.46,47.08,47.08,0,0,1-5.89-1.92A33.86,33.86,0,0,1,1173.62,650.7Z"
            fill="#a285c1"
          />
        </g>
        <rect
          x="1597.28"
          y="493.12"
          width="31.72"
          height="166.73"
          fill="#6d265c"
        />
        <rect
          x="1597.28"
          y="493.12"
          width="3.69"
          height="166.73"
          fill="#e9847e"
          opacity="0.46"
        />
        <g>
          <polygon
            points="1538.16 524.1 1538.16 582.73 1538.16 670.66 1512.78 656.01 1512.78 568.07 1538.16 524.1"
            fill="#822c69"
          />
          <polygon
            points="1538.16 524.1 1538.16 582.73 1512.78 568.07 1538.16 524.1"
            fill="#e9847e"
            opacity="0.46"
          />
          <polygon
            points="1562.39 567.4 1538.16 524.1 1538.16 582.73 1538.16 670.66 1563.55 655.21 1562.39 567.4"
            fill="#6d265c"
          />
        </g>
        <g>
          <circle
            cx="1483.85"
            cy="613.56"
            r="45.7"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="3.67"
          />
          <circle
            cx="1484.39"
            cy="613.64"
            r="25"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="2.94"
          />
          <circle cx="1484.39" cy="613.64" r="3.83" fill="#3d2651" />
          <polyline
            points="1516.63 581.71 1484.31 613.56 1527.82 601.06"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <polyline
            points="1520.49 640.88 1484.24 613.48 1528.86 621.52"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <polyline
            points="1483.78 659.18 1484.24 613.48 1506.07 653.51"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <polyline
            points="1445.64 638.63 1484.24 613.48 1465.17 655.28"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <polyline
            points="1441 597.64 1484.24 613.48 1438.32 617.47"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <polyline
            points="1467.66 570.81 1484.24 613.48 1451.08 581.71"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <polyline
            points="1502.93 572.02 1484.24 613.48 1485.47 567.56"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.46"
          />
          <ellipse
            cx="1459.59"
            cy="572.95"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse cx="1486.77" cy="565.6" rx="8.36" ry="5.02" fill="#4d3468" />
          <ellipse
            cx="1511.01"
            cy="574.42"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse
            cx="1526.43"
            cy="592.04"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse
            cx="1529.37"
            cy="612.61"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse
            cx="1526.43"
            cy="634.64"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse
            cx="1509.54"
            cy="651.53"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <g>
            <ellipse
              cx="1484.57"
              cy="658.88"
              rx="8.36"
              ry="5.02"
              fill="#4d3468"
            />
            <path
              d="M1486.77,663.17c-4.62,0-8.36-2.25-8.36-5,0-1.61,1.28-3,3.26-4-3.19.71-5.46,2.55-5.46,4.71,0,2.77,3.74,5,8.36,5a12.17,12.17,0,0,0,5.1-1A13.49,13.49,0,0,1,1486.77,663.17Z"
              fill="#dba877"
              opacity="0.57"
            />
          </g>
          <polyline
            points="1445.59 670.38 1484.16 613.41 1521.35 668.23"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="4.14"
          />
          <ellipse cx="1461.06" cy="653" rx="8.36" ry="5.02" fill="#4d3468" />
          <ellipse
            cx="1441.23"
            cy="636.11"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse
            cx="1435.36"
            cy="613.34"
            rx="8.36"
            ry="5.02"
            fill="#4d3468"
          />
          <ellipse cx="1442.7" cy="592.04" rx="8.36" ry="5.02" fill="#4d3468" />
        </g>
        <g opacity="0.51">
          <polygon
            points="1518.17 495.5 1520.55 496.81 1518.17 498.11 1516.86 500.49 1515.56 498.11 1513.17 496.81 1515.56 495.5 1516.86 493.12 1518.17 495.5"
            fill="#8af1eb"
          />
          <image
            width="80"
            height="80"
            transform="translate(1477 457)"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAAAsSAAALEgHS3X78AAADrUlEQVR4Xu3az2obVxSA8e/cq7HkRlEU2URJaCBtdvYyqy4KeQk9Qx+j9utIr9CFIYuuTFb1shQq7KpOFNvItkaje08XiiEE2kAPZSb0/HaCixaf7r8RI6qK+/fC5wa4f+YBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtCo9bkBdRGQjz8rNPI9vMbNQAE5hDCGcHB0FMcQRpNJAOTTqE0gDXvBUiYQTiD2mMY0KwLA9XCYnkD6aTLJ49Eo06DZ2JiAh5vVEHpMC7notquq6miMrWJbtZXaq/lqVQ4Gg/IxrEfQmIhNWcIChHuzWXu5aHUrWe3Egieh4Fmq+LqkGnZE+teXl19Np9Otw6OjSEOWc+0zUEDGEKZMt5aLVjdqayCJx4g+0kBXNCTNehGCzNaaztvSubjqzW9+4Xk1gVz34VL7KXwAcgLxwUW33ZJVL8TWkFg9zxqeSda+BNZE3iLSCbklZb7JnfcP0v7ZSd7f21P+zwEFZATyHdN4WbU77UJ6gfwoK89QvgEGCgmVnpIJImUowg1a3PT2equfIQlInbOw9j1wnyNJFGE7xlYIsY3qPUTuC7kvQfoCD0EHotJH0/0q6XYZyyLNirDPUe37YO0B93ilsxnQyRlWWVUrVFcqUmbNlWpek1lrTkkJSdBcqOr1cKh7vKpt5t2pPeCECd3hbYqpvUqBhaJzhZnCWZBwqnCG8AdB/gwxzEMoFjG1V/BbnjD53Nf/52rdAzd71yj/wHF6UXbLfK+4TOs8a6kUGiRlzfPNSJkj/J4JsyqmK67L8vT+uzSm/kt1rQFhc5k74GW63aXsvP91IZ2+aJlUCUuJsQegiStJ+Vxb+W1rebm43f22fMpuEmquRwMCKqgAI0jfP8xLQG+vJSfRpWjeBtAUbqPK1XafBdu5PIY0Aa3z9L1T+x4Im4hjyK95s54zWHZVr9jaOo8FZ7HgjK2t867q1ZzB8jVv1uMGXKDv1P4k8jEBOQA5PT6OT3d2Iu325gcuy3z67l16+vJlOmjIzLvTqICwiajAIcjeh+fdE9AfPyz1JsWDBga886X8oVr7IfJ3mhrsU404RL5kHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjTygkQc08oBGHtDIAxp5QCMPaOQBjf4Cnup+iq4nf6sAAAAASUVORK5CYII="
          />
        </g>
        <g opacity="0.5">
          <polygon
            points="1557.18 462.76 1560.76 464.71 1557.18 466.67 1555.23 470.25 1553.27 466.67 1549.69 464.71 1553.27 462.76 1555.23 459.18 1557.18 462.76"
            fill="#8af1eb"
          />
          <image
            width="84"
            height="84"
            transform="translate(1513 423)"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAAsSAAALEgHS3X78AAAEhElEQVR4Xu3azW4TVxTA8f85M+MPHOKEJFC3FNISimS66wuw6CuYV+hjkLwOfonsusoOZYWQBTSfyPkAx56Pe08XkIK6QZVuNdPq/neWRhr7pzMz91ojZkYsXPq1A2L/rAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauAgauPRrB9SdgHz52aDR7182dkI/QcpoPNbnoNu7u8lz0B3QvyM3KWniC7cCsg0y2NtLDtfWksHmpl4eH0tSlv7y8tINh0M3Ak8Dp7VxoNeYsJ9unG605p2q4/KsVYpIu12VrpzliwvNh5ubZRNRGwX6GZOU6bTT9X4JkT6p9RDRLNG5LxeXpdy4zPtn8yHNQ23SPVRGoLdevsxuMe10mS9Larctc/dM2AJ7WJbuB9PWNymLlfbFanefSTb++Bsac09tyoTKGPQI0ivOOtV8vtwqWhuifGcm98BuG5Igdqbe3nhJXvuWHpHLRdMmtfYJFZCn47Ee8TKdnk+6LOhnhdwxlXtmugU8Ah6p8EjQnwy2xNx9LfLPkzqZZE8b8vSvfR1qwG+jH3X+bqXV1XxJvFs3bd3F2QPUHgD3gXUzU2AF1RTvUVXDqzlvvtP3/vH+vn88HBo1T2ntoDsgP9PXqtXKSqFnpV+TJBmg8j3Y9wIDQ1bBFOhihiHOjByxhVgxT7LefHnYKn4HJyB1Lv5rv+QBpqTiRdREU1Ft46xn5pcwljz0EOsCNzC7CayoyqqarGLcTJOkk+dp5o4zfcxuvOQBblFZZeYFX5nXHLErRWaYzRHJ8VaZgAgOcObNmVApOG/msy42u3HHhtypbTKvq31Cn4G94MKXRVFS6szjpyhH3vyBYYd4e4fKGXCBcQacInIEcmKJTqnKWeLKAiZ+zPhrp/vXq31CBRiNX/nuqF+48/UPrq1JUeSpoqmiqQkq5gszaQEXeHsjKq8Qe+1LdyyWXXy4aYsDDtxzRrUvnWoHNTBGIz+Gav98smivqkh7WZLSq6vKNMlSzDNDyfCco/raYROcfystPWWF93BafMsvTqhZk+Ys7OHT4n6fSdZmtUvOalL4Ab66S6LreEnNu8tEkwNz1aFv6zuueD9fP8lhWG2D1fl0v65JoPAXKlnr/R+91GcrJska5vomqapzV97c1HXSaXrFh/nJSc6wOZjQPFAA2WE3WX67lbFM1yrt5b7VTdqIeleQMJvN9WqwsZEfgnv2ccvZmJoICiA7u7sJm5tpd2kp81mWtkWkcM4tFotyMBiUh+C2GzSZ1zUVFECegv66t6cv+n19uAXT/cI4OfE8eeK3G4gJzQbl0zaSnS/+9HgGJiJYQ794o0H/i9W+U/q/FUEDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0EDF0ED9yfu7gKd6bqNpwAAAABJRU5ErkJggg=="
          />
        </g>
        <circle
          cx="1562.6"
          cy="531.48"
          r="1.48"
          fill="#efef8b"
          opacity="0.47"
        />
        <polygon
          points="1538.26 524.1 1538.26 582.38 1562.6 567.63 1538.26 524.1"
          fill="#631c56"
        />
        <polygon
          points="1557.44 602.06 1557.44 605.25 1561.13 602.55 1561.13 599.35 1557.44 602.06"
          fill="#baa36a"
        />
        <polygon
          points="1547.11 592.47 1547.11 595.66 1550.8 592.96 1550.8 589.76 1547.11 592.47"
          fill="#baa36a"
        />
        <polygon
          points="1553.75 579.19 1553.75 582.38 1557.44 579.68 1557.44 576.48 1553.75 579.19"
          fill="#baa36a"
        />
        <rect
          x="1605.39"
          y="500.49"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <rect
          x="1618.67"
          y="513.77"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <rect x="1618.67" y="524.1" width="7.38" height="2.95" fill="#baa36a" />
        <rect x="1618.67" y="530" width="7.38" height="2.95" fill="#baa36a" />
        <rect
          x="1611.29"
          y="533.69"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <rect
          x="1611.29"
          y="539.59"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <rect
          x="1614.98"
          y="575.01"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <rect
          x="1607.61"
          y="559.51"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <rect
          x="1618.67"
          y="582.38"
          width="7.38"
          height="2.95"
          fill="#baa36a"
        />
        <g>
          <g opacity="0.51">
            <polygon
              points="584.19 126.69 588.57 129.08 584.19 131.48 581.79 135.87 579.39 131.48 575 129.08 579.39 126.69 581.79 122.3 584.19 126.69"
              fill="#8af1eb"
            />
            <use
              transform="translate(539 86)"
              xlinkHref="#a986ed6f-0b40-453e-a94c-dec2035ef9ff"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="771.35 135.67 777.94 139.26 771.35 142.87 767.75 149.45 764.16 142.87 757.57 139.26 764.16 135.67 767.75 129.08 771.35 135.67"
              fill="#8af1eb"
            />
            <use
              transform="translate(721 93)"
              xlinkHref="#aeff00c8-713c-4c6e-aa65-8a1c4e61f8a2"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="1075.42 126.16 1082 129.76 1075.42 133.36 1071.82 139.94 1068.22 133.36 1061.64 129.76 1068.22 126.16 1071.82 119.58 1075.42 126.16"
              fill="#8af1eb"
            />
            <use
              transform="translate(1025 83)"
              xlinkHref="#f7707b16-cd19-49ca-ab7b-c4865bdcfa62"
            />
          </g>
          <circle
            cx="898.07"
            cy="70.71"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="929.29"
            cy="112.8"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="812.55"
            cy="146.73"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="678.16"
            cy="139.94"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
        </g>
        <g>
          <g opacity="0.51">
            <polygon
              points="486.19 289.69 490.57 292.08 486.19 294.48 483.79 298.87 481.39 294.48 477 292.08 481.39 289.69 483.79 285.3 486.19 289.69"
              fill="#8af1eb"
            />
            <use
              transform="translate(441 249)"
              xlinkHref="#a986ed6f-0b40-453e-a94c-dec2035ef9ff"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="977.42 289.16 984 292.76 977.42 296.36 973.82 302.94 970.22 296.36 963.64 292.76 970.22 289.16 973.82 282.58 977.42 289.16"
              fill="#8af1eb"
            />
            <use
              transform="translate(927 246)"
              xlinkHref="#f7707b16-cd19-49ca-ab7b-c4865bdcfa62"
            />
          </g>
          <circle
            cx="800.07"
            cy="233.71"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="831.29"
            cy="275.8"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="714.55"
            cy="309.73"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="580.16"
            cy="302.94"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
        </g>
        <g>
          <g opacity="0.51">
            <polygon
              points="131.19 40.69 135.57 43.08 131.19 45.48 128.79 49.87 126.39 45.48 122 43.08 126.39 40.69 128.79 36.3 131.19 40.69"
              fill="#8af1eb"
            />
            <use
              transform="translate(86)"
              xlinkHref="#a986ed6f-0b40-453e-a94c-dec2035ef9ff"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="248.35 79.67 254.94 83.27 248.35 86.86 244.75 93.45 241.16 86.86 234.57 83.27 241.16 79.67 244.75 73.08 248.35 79.67"
              fill="#8af1eb"
            />
            <use
              transform="translate(198 37)"
              xlinkHref="#aeff00c8-713c-4c6e-aa65-8a1c4e61f8a2"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="552.42 70.16 559 73.76 552.42 77.36 548.82 83.94 545.22 77.36 538.64 73.76 545.22 70.16 548.82 63.58 552.42 70.16"
              fill="#8af1eb"
            />
            <use
              transform="translate(502 27)"
              xlinkHref="#f7707b16-cd19-49ca-ab7b-c4865bdcfa62"
            />
          </g>
          <circle
            cx="375.07"
            cy="14.71"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="406.29"
            cy="56.8"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="289.55"
            cy="90.73"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="155.16"
            cy="83.94"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
        </g>
        <g>
          <g opacity="0.51">
            <polygon
              points="1093.19 369.69 1097.57 372.08 1093.19 374.48 1090.79 378.87 1088.39 374.48 1084 372.08 1088.39 369.69 1090.79 365.3 1093.19 369.69"
              fill="#8af1eb"
            />
            <use
              transform="translate(1048 329)"
              xlinkHref="#a986ed6f-0b40-453e-a94c-dec2035ef9ff"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="1280.35 378.67 1286.94 382.26 1280.35 385.87 1276.76 392.45 1273.16 385.87 1266.57 382.26 1273.16 378.67 1276.76 372.08 1280.35 378.67"
              fill="#8af1eb"
            />
            <use
              transform="translate(1230 336)"
              xlinkHref="#aeff00c8-713c-4c6e-aa65-8a1c4e61f8a2"
            />
          </g>
          <g opacity="0.5">
            <polygon
              points="1584.42 369.16 1591 372.76 1584.42 376.36 1580.82 382.94 1577.22 376.36 1570.64 372.76 1577.22 369.16 1580.82 362.58 1584.42 369.16"
              fill="#8af1eb"
            />
            <use
              transform="translate(1534 326)"
              xlinkHref="#f7707b16-cd19-49ca-ab7b-c4865bdcfa62"
            />
          </g>
          <circle
            cx="1407.07"
            cy="313.71"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="1438.29"
            cy="355.8"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="1321.55"
            cy="389.73"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
          <circle
            cx="1187.16"
            cy="382.94"
            r="2.71"
            fill="#efef8b"
            opacity="0.47"
          />
        </g>
        <g>
          <path
            d="M1120.89,638.71s5.48,11.14-1.28,17.32l10.58-.09s-3.89-1.87-4.38-3.09-.61-9.12-4-13.78Z"
            fill="#6d4c89"
          />
          <path
            d="M1122.25,639.25s.51-6.47,4.2-7.34c0,0-1.53,1.33-.75,2.39,0,0,1.37-3.19,5.66-2.43,0,0-4.93.65-5.65,3.63a3.44,3.44,0,0,1,3.79,1.12S1122.22,636.81,1122.25,639.25Z"
            fill="#6d4c89"
          />
          <path
            d="M1120.89,639.26s-.62-6.46-4.32-7.26c0,0,1.54,1.3.78,2.37,0,0-1.43-3.16-5.7-2.33,0,0,4.94.56,5.71,3.54a3.43,3.43,0,0,0-3.77,1.18S1120.87,636.82,1120.89,639.26Z"
            fill="#6d4c89"
          />
          <path
            d="M1122.71,640.39s-7.22-9.24-15.15-5.6c0,0,4.5-.2,4.88.32,0,0-1.48-.22-1.39,1.24,0,0,3-1.5,3.92-.78,0,0-1.7.36-1.59,1.07,0,0,2.72-.67,3.43,0,0,0-1.76.42-1,1.26,0,0,2.41-1.06,3.58.49,0,0-1-.33-1.32,0C1118,638.39,1122.52,639.44,1122.71,640.39Z"
            fill="#6d4c89"
          />
          <path
            d="M1121.39,640.27s6-8.85,14.31-4.45c0,0-4.48-.59-4.79-.08a1.4,1.4,0,0,1,1.52,1.38s-3.19-1.79-4-1.13c0,0,1.72.51,1.7,1.23,0,0-2.77-.92-3.4-.33,0,0,1.79.58,1.19,1.38,0,0-2.5-1.29-3.48.2,0,0,1-.26,1.31.15C1125.78,638.62,1121.46,639.31,1121.39,640.27Z"
            fill="#6d4c89"
          />
          <path
            d="M1122.87,639.88s-6.83-5.34-12.26,2c0,0,3.36-2.41,3.73-2.09a1.64,1.64,0,0,0-.87,1.87s2.08-2.93,2.84-2.67c0,0-1.22,1.17-1,1.81,0,0,2-2,2.59-1.72,0,0-1.27,1.27-.61,1.72,0,0,1.66-2.2,2.77-1.28,0,0-.81.18-1,.69C1119,640.26,1122.58,639.06,1122.87,639.88Z"
            fill="#6d4c89"
          />
          <path
            d="M1120.9,640.08s8-6.28,14.39,1.81c0,0-4-2.57-4.38-2.19a1.76,1.76,0,0,1,1,2.06s-2.43-3.21-3.33-2.88c0,0,1.44,1.27,1.22,2,0,0-2.29-2.15-3-1.84,0,0,1.48,1.38.7,1.92,0,0-1.94-2.41-3.25-1.33,0,0,1,.17,1.17.73C1125.4,640.35,1121.23,639.14,1120.9,640.08Z"
            fill="#6d4c89"
          />
          <path
            d="M1122.08,640.26c-.33-3.73,3.58-8.11,6.41-7.87,0,0-5.61-1-6.48,2.32,0,0,1.09-4.45,2.75-4.46,0,0-3.66-1-4.29,2.12,0,0-2-3.83,0-4.37,0,0-4.5,1.24-2.54,4.21,0,0-2.08-1.7-4.51.59,0,0,4.81,0,5.64,1.94,0,0-2.12-1.34-3.35,0,0,0,4.22-.74,5.32,2.38Z"
            fill="#6d4c89"
          />
          <path
            d="M1121.85,640.27c-.25-2.88,2.76-6.27,4.94-6.07,0,0-4.32-.81-5,1.79,0,0,.85-3.44,2.12-3.45,0,0-2.82-.74-3.3,1.64,0,0-1.55-3,0-3.37,0,0-3.47,1-2,3.25a2.56,2.56,0,0,0-3.47.45s3.71,0,4.35,1.5c0,0-1.64-1-2.59,0,0,0,3.26-.57,4.11,1.83Z"
            fill="#6d4c89"
          />
          <path
            d="M1121.49,641.41s.3-3.74,2.43-4.24c0,0-.88.76-.43,1.37a2.84,2.84,0,0,1,3.27-1.4s-2.85.38-3.26,2.1a2,2,0,0,1,2.19.65S1121.48,640,1121.49,641.41Z"
            fill="#6d4c89"
          />
          <path
            d="M1122.13,640.86s-.36-3.73-2.5-4.2c0,0,.89.75.45,1.37a2.83,2.83,0,0,0-3.29-1.35s2.85.33,3.3,2.05a2,2,0,0,0-2.18.68S1122.12,639.45,1122.13,640.86Z"
            fill="#6d4c89"
          />
          <path
            d="M1125.81,652.85c-.44-1.1-.58-7.62-3.06-12.3.34,1.29,2.61,10.15,1.5,12.7-.44,1,1,1.94,3.07,2.71l2.87,0S1126.3,654.07,1125.81,652.85Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M1089.84,632.45s-5.3,13.94,1.4,21.55h-10.39s3.81-2.37,4.27-3.89.52-11.37,3.79-17.21Z"
            fill="#6d4c89"
          />
          <path
            d="M1088.51,633.14s-.56-8-4.19-9.09c0,0,1.51,1.63.76,3a4.68,4.68,0,0,0-5.59-3s4.85.75,5.59,4.46c0,0-2.09-1-3.72,1.43C1081.36,629.94,1088.51,630.1,1088.51,633.14Z"
            fill="#6d4c89"
          />
          <path
            d="M1089.84,633.14s.56-8,4.19-9.09c0,0-1.51,1.63-.75,3a4.67,4.67,0,0,1,5.58-3s-4.85.75-5.58,4.46c0,0,2.09-1,3.71,1.43C1097,629.94,1089.84,630.1,1089.84,633.14Z"
            fill="#6d4c89"
          />
          <path
            d="M1088.07,634.56s7-11.58,14.84-7.13c0,0-4.43-.21-4.8.45,0,0,1.45-.28,1.38,1.52,0,0-3-1.82-3.86-.92,0,0,1.67.42,1.57,1.32,0,0-2.68-.81-3.37,0,0,0,1.73.51,1,1.56,0,0-2.37-1.3-3.51.65,0,0,1-.43,1.3,0C1092.66,632,1088.24,633.37,1088.07,634.56Z"
            fill="#6d4c89"
          />
          <path
            d="M1089.36,634.4s-6-10.95-14.1-5.38c0,0,4.39-.79,4.71-.16,0,0-1.41-.11-1.48,1.73,0,0,3.12-2.25,3.88-1.44,0,0-1.68.65-1.65,1.55,0,0,2.71-1.17,3.33-.45,0,0-1.75.74-1.15,1.73,0,0,2.45-1.63,3.41.21,0,0-.94-.31-1.28.21C1085,632.4,1089.28,633.21,1089.36,634.4Z"
            fill="#6d4c89"
          />
          <path
            d="M1087.91,633.93s6.65-6.72,12.06,2.42c0,0-3.33-3-3.68-2.56a2.15,2.15,0,0,1,.86,2.31s-2.06-3.62-2.81-3.28c0,0,1.21,1.44,1,2.24,0,0-1.93-2.45-2.55-2.12,0,0,1.25,1.57.61,2.14,0,0-1.64-2.72-2.73-1.56,0,0,.8.21,1,.84C1091.68,634.36,1088.18,632.9,1087.91,633.93Z"
            fill="#6d4c89"
          />
          <path
            d="M1089.84,634.16s-7.92-7.73-14.12,2.41c0,0,3.86-3.24,4.28-2.78a2.32,2.32,0,0,0-1,2.58s2.37-4,3.25-3.62c0,0-1.4,1.59-1.18,2.49,0,0,2.24-2.71,3-2.32,0,0-1.45,1.73-.68,2.4,0,0,1.88-3,3.18-1.69,0,0-.94.21-1.13.91C1085.43,634.54,1089.51,633,1089.84,634.16Z"
            fill="#6d4c89"
          />
          <path
            d="M1088.68,634.4c.29-4.65-3.58-10.07-6.36-9.73,0,0,5.5-1.35,6.39,2.82,0,0-1.12-5.53-2.74-5.53,0,0,3.58-1.24,4.23,2.6,0,0,1.93-4.8,0-5.45,0,0,4.43,1.5,2.54,5.22,0,0,2-2.14,4.42.68,0,0-4.71.11-5.52,2.48,0,0,2.07-1.69,3.3,0,0,0-4.16-.87-5.21,3Z"
            fill="#6d4c89"
          />
          <path
            d="M1088.91,634.4c.22-3.59-2.76-7.77-4.91-7.5,0,0,4.24-1,4.93,2.17,0,0-.86-4.26-2.11-4.26a2.38,2.38,0,0,1,3.26,2s1.49-3.7,0-4.2c0,0,3.41,1.15,2,4,0,0,1.57-1.65,3.42.53,0,0-3.64.08-4.26,1.91,0,0,1.6-1.3,2.54,0,0,0-3.21-.67-4,2.33Z"
            fill="#6d4c89"
          />
          <path
            d="M1089.27,635.82s-.33-4.65-2.42-5.26c0,0,.87,1,.43,1.71a2.7,2.7,0,0,0-3.23-1.71s2.81.44,3.23,2.58a1.68,1.68,0,0,0-2.14.83S1089.27,634.06,1089.27,635.82Z"
            fill="#6d4c89"
          />
          <path
            d="M1088.64,635.14s.32-4.65,2.42-5.25c0,0-.87.94-.44,1.71a2.71,2.71,0,0,1,3.23-1.71s-2.8.43-3.23,2.58a1.7,1.7,0,0,1,2.15.82S1088.64,633.38,1088.64,635.14Z"
            fill="#6d4c89"
          />
          <path
            d="M1085.12,650.11c.42-1.37.51-9.49,2.91-15.35-.33,1.61-2.48,12.67-1.37,15.83.44,1.26-1,2.43-3,3.41h-2.82S1084.66,651.63,1085.12,650.11Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M1120.82,781c8.67-14.32,11.62-17.58,7.94-27.22s-7.23-1.41-3.54-19.56-10.35-23.53-16.73-24.24-36.57,17-31.47,26.65,7.28,37,1.8,39.26S1110.61,797.91,1120.82,781Z"
            fill="#396039"
          />
          <path
            d="M1115,747.73c-.28-7.8,11.48-10.92,7.65-14.46s-8.36-12.76-12.05-7.94-6.52,11.91-9.35,7.94-6-4.11-7.8,0-.28,9.21-4.68,7.94-6.37.71-5.81,5,3.83,2.55,6.66,7.65,15.6,4.4,13.47,1.56S1115,747.73,1115,747.73Z"
            fill="#447244"
          />
          <path
            d="M1137,734.26c6.38-10.06,15.31-19.28,24.24-10.63s-6,24.1,0,30.19,4.68,21.55,0,22.12-26.93.56-32.74,3.26S1115.15,772,1115,762.33,1137,734.26,1137,734.26Z"
            fill="#6b996b"
          />
          <path
            d="M1103.39,793.94c14.93,11.38,16-28.21,0-24.81s-21.27,2.41-26.37-4.68-17.86,5.39-18.29,8.94,3.69,15.45,12.48,18.85S1094.45,787.14,1103.39,793.94Z"
            fill="#447244"
          />
          <path
            d="M1134.25,801.88c-14.94,11.38-16-28.21,0-24.81s21.26,2.41,26.36-4.68,17.86,5.39,18.29,8.93-3.69,15.45-12.48,18.86S1143.18,795.07,1134.25,801.88Z"
            fill="#447244"
          />
          <path
            d="M1152.86,788.27c2.12-4.25,8.36,4,8.36,4s-.42-5.53,3-7.51,5,3.11,5,3.11c.28-4,8.36-.28,6.1,4.44h0a18.94,18.94,0,0,1-8.84,7.9,15.6,15.6,0,0,1-6.32.81l-7.62-1.94S1150.73,792.52,1152.86,788.27Z"
            fill="#396039"
          />
          <path
            d="M1122.1,795.5c-3,5.24-4.68,52.45,0,74.14,0,0-13.61-2.41-17.86-.15-.43,1.42-.43.15-.43.15s18.85-65.64,2.41-84.91-34.3,0-34.3,0,4.82-11.34,15.45-12.2,25.23,12.9,25.94,15.6c0,0,.56-20.7-6.1-27.93s1.85-12.47,1.85-12.47-8.79,2.69,5.38,21.12c7.35,9.55,2.13,27.36,2.13,27.36s4.53-13.89,15.87-10.92,18.15,16.16,28.78,15.31c0,0-12.47-.71-22.4-6.66S1122.1,795.5,1122.1,795.5Z"
            fill="#704d3c"
          />
          <path
            d="M1137.61,793.27a13,13,0,0,0-15.51,2.23c-1,1.81-1.9,8.59-2.42,17.6-3.4-11.75,2.7-25.68,4.63-26.93a10.7,10.7,0,0,1,8.13-.88,24.89,24.89,0,0,1,7.48,3.56Z"
            fill="#634b42"
          />
          <path
            d="M1111.54,788.91c1.56,3.54,3.26,13.93,1.34,19.3h0c-.36-9.73-2.23-18.29-6.66-23.48a31.94,31.94,0,0,0-3-3.05c-.4-1.22-.66-2-.66-2C1105,781,1110,785.36,1111.54,788.91Z"
            fill="#44322c"
          />
          <path
            d="M1134.46,791.07c4.11-1.33,4.37-7.09,9.23-6.76s5.44,7.34,9.48,11.88,7.34,3.54,10.56,5.11-8.82,18.88-20,12.61-10.14-5.19-14-7.75S1125.31,794,1134.46,791.07Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1113.19,782.18c.08.25.08.28,0,.13v-.13Z" fill="#7f2c03" />
            <path
              d="M1113,779.67c-.53-6.58-2-15.28-5.82-19.47a8.52,8.52,0,0,1-2.53-5.12l2-.38c.69,3.15,2.84,7.68,7.81,14.15l.33.44C1114.42,773,1113.26,776.85,1113,779.67Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1097.67,779.16c-2.69-3.38.27-8.32-4-10.73s-8.59,3.11-14.46,4.66-8.08-1.09-11.63-1.56-3.06,20.61,9.75,21.58,11.32,1.27,16,1.27S1103.67,786.69,1097.67,779.16Z"
            fill="#6b996b"
          />
          <path
            d="M1103.08,739.37c2.79-4.4,6.7-8.43,10.6-4.65s-2.6,10.55,0,13.21,2,9.43,0,9.68-11.78.25-14.33,1.43-5.83-3.17-5.89-7.39S1103.08,739.37,1103.08,739.37Z"
            fill="#6b996b"
          />
          <path
            d="M1075.17,788.4c.8,1.22,3.16,1,4.53.44s2.15-4.74,4.36-4,3.27,2.91,5.73,2.2,1.38-3.34,4.52-3.39c2.9,0,5.83,1.14,5.93,2.76,0,.14,0,.27,0,.4h0a2.18,2.18,0,0,0,0,.38c-.57,4.15-3.91,7.21-6.84,7.2-4.64,0-3.16-.31-16-1.27a10.36,10.36,0,0,1-4.72-1.5C1071.24,790.68,1074.36,787.18,1075.17,788.4Z"
            fill="#447244"
          />
          <path
            d="M1132.73,806.13c3.12,0,9.35,3.4,10.2.28s7.09-3.82,7.8-2.41,4.54,3.26,6.66,2.13,4.26,1.7,3.29,2.82c-4,4.46-10.6,8.53-17,5-7.78-4.34-9.64-5.16-11.35-6.1C1131.61,807.27,1130.34,806.13,1132.73,806.13Z"
            fill="#396039"
          />
          <path
            d="M1121.1,770.27c2-4.4,6.81-3.55,10.21-3s2.41,5.1,5.1,3,8.65,3,6.4,6.66h0c-6,.42-11.78,1.08-14.33,2.27-3.6,1.66-7.85-1.51-10.6-6.45l-1.2-2.5h0S1119.12,774.66,1121.1,770.27Z"
            fill="#447244"
          />
          <path
            d="M1157.11,767.57c-1.28-4,4.39-7.37,0-7.37s-11.62,4.4-10.91-2-1.28-9.78-6.1-9.36-8.5-9.92-5.81-12.26-15,4.46-7.23,11.13,10.63,4.53,10.35,7.65,0,9.64,5.95,10.63-1.69,9.08,2.77,10.92S1160.51,778.2,1157.11,767.57Z"
            fill="#447244"
          />
          <path
            d="M1103.81,869.64s1.17-4.07,2.67-10.48c11.84-6.08,12.69-25.85,12.71-26.44.06,13.44.89,27.56,2.91,36.92,0,0-13.61-2.41-17.86-.15C1103.81,870.91,1103.81,869.64,1103.81,869.64Z"
            fill="#44322c"
          />
          <path
            d="M1117.94,869c.08-3.83-1.25-7.46-1.74-11.25a75.11,75.11,0,0,1-.23-11.42c.15-3.81.54-7.59.8-11.37s.55-7.58.75-11.36c.1-1.89.2-3.79.23-5.68a21,21,0,0,0-.1-2.77c-.15-.86-.47-1.82-.67-2.73a35,35,0,0,1-1-5.67,11.53,11.53,0,0,1,.77-5.76c.86-1.71,1.68-3.42,2.67-5.07a13.19,13.19,0,0,1,3.79-4.32,9.52,9.52,0,0,1,5.55-1.33,24.9,24.9,0,0,1,5.64.79,25,25,0,0,0-5.64-.58,9.19,9.19,0,0,0-5.32,1.46,12.91,12.91,0,0,0-3.56,4.26c-.93,1.63-1.72,3.36-2.54,5.07a7.85,7.85,0,0,0-.63,2.64,15.19,15.19,0,0,0,0,2.78,34.06,34.06,0,0,0,1,5.54c.21.93.51,1.79.7,2.79a22.18,22.18,0,0,1,.13,2.91c0,1.91-.1,3.81-.2,5.71-.43,7.59-1.19,15.17-1.74,22.72a75.44,75.44,0,0,0,0,11.35C1117,861.49,1118.16,865.21,1117.94,869Z"
            fill="#44322c"
          />
          <path
            d="M1114.94,832.71a36.69,36.69,0,0,0,0,4.69,7.08,7.08,0,0,1-.28,2.4,6.8,6.8,0,0,1-1.25,2.09c-.25.31-.56.61-.78.9a6,6,0,0,0-.69.88,11.2,11.2,0,0,0-1,2,16.51,16.51,0,0,0-1,4.45,19,19,0,0,0,0,4.58,14.63,14.63,0,0,0,.51,2.22c.24.71.52,1.5.7,2.26a37.53,37.53,0,0,1,1,9.37c-.15-1.56-.34-3.11-.61-4.65a36.39,36.39,0,0,0-1-4.54c-.23-.75-.5-1.43-.77-2.2a14.52,14.52,0,0,1-.57-2.34,19.62,19.62,0,0,1-.13-4.78,17.93,17.93,0,0,1,1.13-4.66,11,11,0,0,1,1.15-2.13,12,12,0,0,1,1.58-1.79,6.15,6.15,0,0,0,1.23-1.86,6.47,6.47,0,0,0,.37-2.22A28.38,28.38,0,0,1,1114.94,832.71Z"
            fill="#44322c"
          />
          <path
            d="M1114.94,772.46c.12.9.3,1.77.5,2.65a12.51,12.51,0,0,1,.46,2.69,5.83,5.83,0,0,1-.14,1.38c0,.23-.13.46-.17.67a2.91,2.91,0,0,0-.06.6A10.68,10.68,0,0,0,1116,783c1,3.4,2,7,1.54,10.74a18.54,18.54,0,0,1-.6,2.7l-.33,1.27-.23,1.3a36.13,36.13,0,0,0-.27,5.31,53.23,53.23,0,0,0,.38,5.35c.2,1.78.48,3.55.82,5.32a47.92,47.92,0,0,1-1.85-10.64,29.24,29.24,0,0,1,.15-5.45l.22-1.35.33-1.34a19.6,19.6,0,0,0,.54-2.57,17.78,17.78,0,0,0-.12-5.25c-.28-1.75-.79-3.46-1.21-5.22a10.66,10.66,0,0,1-.41-2.73,3.21,3.21,0,0,1,.1-.74c.06-.23.14-.41.19-.63a5.59,5.59,0,0,0,.2-1.28,12.59,12.59,0,0,0-.27-2.64A20.27,20.27,0,0,1,1114.94,772.46Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M1399.82,774c8.67-14.32,11.62-17.58,7.94-27.22s-7.23-1.41-3.54-19.56-10.35-23.53-16.73-24.24-36.57,17-31.47,26.65,7.28,37,1.8,39.26S1389.61,790.91,1399.82,774Z"
            fill="#396039"
          />
          <path
            d="M1394,740.73c-.28-7.8,11.48-10.92,7.65-14.46s-8.36-12.76-12.05-7.94-6.52,11.91-9.35,7.94-6-4.11-7.8,0-.28,9.21-4.68,7.94-6.37.71-5.81,5,3.83,2.55,6.66,7.65,15.6,4.4,13.47,1.56S1394,740.73,1394,740.73Z"
            fill="#447244"
          />
          <path
            d="M1416,727.26c6.38-10.06,15.31-19.28,24.24-10.63s-6,24.1,0,30.19,4.68,21.55,0,22.12-26.93.56-32.74,3.26S1394.15,765,1394,755.33,1416,727.26,1416,727.26Z"
            fill="#6b996b"
          />
          <path
            d="M1382.39,786.94c14.93,11.38,16-28.21,0-24.81s-21.27,2.41-26.37-4.68-17.86,5.39-18.29,8.94,3.69,15.45,12.48,18.85S1373.45,780.14,1382.39,786.94Z"
            fill="#447244"
          />
          <path
            d="M1413.25,794.88c-14.94,11.38-16-28.21,0-24.81s21.26,2.41,26.36-4.68,17.86,5.39,18.29,8.93-3.69,15.45-12.48,18.86S1422.18,788.07,1413.25,794.88Z"
            fill="#447244"
          />
          <path
            d="M1431.86,781.27c2.12-4.25,8.36,4,8.36,4s-.42-5.53,3-7.51,5,3.11,5,3.11c.28-4,8.36-.28,6.1,4.44h0a18.94,18.94,0,0,1-8.84,7.9,15.6,15.6,0,0,1-6.32.81l-7.62-1.94S1429.73,785.52,1431.86,781.27Z"
            fill="#396039"
          />
          <path
            d="M1401.1,788.5c-3,5.24-4.68,52.45,0,74.14,0,0-13.61-2.41-17.86-.15-.43,1.42-.43.15-.43.15s18.85-65.64,2.41-84.91-34.3,0-34.3,0,4.82-11.34,15.45-12.2,25.23,12.9,25.94,15.6c0,0,.56-20.7-6.1-27.93s1.85-12.47,1.85-12.47-8.79,2.69,5.38,21.12c7.35,9.55,2.13,27.36,2.13,27.36s4.53-13.89,15.87-10.92,18.15,16.16,28.78,15.31c0,0-12.47-.71-22.4-6.66S1401.1,788.5,1401.1,788.5Z"
            fill="#704d3c"
          />
          <path
            d="M1416.61,786.27a13,13,0,0,0-15.51,2.23c-1,1.81-1.9,8.59-2.42,17.6-3.4-11.75,2.7-25.68,4.63-26.93a10.7,10.7,0,0,1,8.13-.88,24.89,24.89,0,0,1,7.48,3.56Z"
            fill="#634b42"
          />
          <path
            d="M1390.54,781.91c1.56,3.54,3.26,13.93,1.34,19.3h0c-.36-9.73-2.23-18.29-6.66-23.48a31.94,31.94,0,0,0-3-3.05c-.4-1.22-.66-2-.66-2C1384,774,1389,778.36,1390.54,781.91Z"
            fill="#44322c"
          />
          <path
            d="M1413.46,784.07c4.11-1.33,4.37-7.09,9.23-6.76s5.44,7.34,9.48,11.88,7.34,3.54,10.56,5.11-8.82,18.88-20,12.61-10.14-5.19-14-7.75S1404.31,787,1413.46,784.07Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1392.19,775.18c.08.25.08.28,0,.13v-.13Z" fill="#7f2c03" />
            <path
              d="M1392,772.67c-.53-6.58-2-15.28-5.82-19.47a8.52,8.52,0,0,1-2.53-5.12l2-.38c.69,3.15,2.84,7.68,7.81,14.15l.33.44C1393.42,766,1392.26,769.85,1392,772.67Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1376.67,772.16c-2.69-3.38.27-8.32-4-10.73s-8.59,3.11-14.46,4.66-8.08-1.09-11.63-1.56-3.06,20.61,9.75,21.58,11.32,1.27,16,1.27S1382.67,779.69,1376.67,772.16Z"
            fill="#6b996b"
          />
          <path
            d="M1382.08,732.37c2.79-4.4,6.7-8.43,10.6-4.65s-2.6,10.55,0,13.21,2,9.43,0,9.68-11.78.25-14.33,1.43-5.83-3.17-5.89-7.39S1382.08,732.37,1382.08,732.37Z"
            fill="#6b996b"
          />
          <path
            d="M1354.17,781.4c.8,1.22,3.16,1,4.53.44s2.15-4.74,4.36-4,3.27,2.91,5.73,2.2,1.38-3.34,4.52-3.39c2.9,0,5.83,1.14,5.93,2.76,0,.14,0,.27,0,.4h0a2.18,2.18,0,0,0,0,.38c-.57,4.15-3.91,7.21-6.84,7.2-4.64,0-3.16-.31-16-1.27a10.36,10.36,0,0,1-4.72-1.5C1350.24,783.68,1353.36,780.18,1354.17,781.4Z"
            fill="#447244"
          />
          <path
            d="M1411.73,799.13c3.12,0,9.35,3.4,10.2.28s7.09-3.82,7.8-2.41,4.54,3.26,6.66,2.13,4.26,1.7,3.29,2.82c-4,4.46-10.6,8.53-17,5-7.78-4.34-9.64-5.16-11.35-6.1C1410.61,800.27,1409.34,799.13,1411.73,799.13Z"
            fill="#396039"
          />
          <path
            d="M1400.1,763.27c2-4.4,6.81-3.55,10.21-3s2.41,5.1,5.1,3,8.65,3,6.4,6.66h0c-6,.42-11.78,1.08-14.33,2.27-3.6,1.66-7.85-1.51-10.6-6.45l-1.2-2.5h0S1398.12,767.66,1400.1,763.27Z"
            fill="#447244"
          />
          <path
            d="M1436.11,760.57c-1.28-4,4.39-7.37,0-7.37s-11.62,4.4-10.91-2-1.28-9.78-6.1-9.36-8.5-9.92-5.81-12.26-15,4.46-7.23,11.13,10.63,4.53,10.35,7.65,0,9.64,5.95,10.63-1.69,9.08,2.77,10.92S1439.51,771.2,1436.11,760.57Z"
            fill="#447244"
          />
          <path
            d="M1382.81,862.64s1.17-4.07,2.67-10.48c11.84-6.08,12.69-25.85,12.71-26.44.06,13.44.89,27.56,2.91,36.92,0,0-13.61-2.41-17.86-.15C1382.81,863.91,1382.81,862.64,1382.81,862.64Z"
            fill="#44322c"
          />
          <path
            d="M1396.94,862c.08-3.83-1.25-7.46-1.74-11.25a75.11,75.11,0,0,1-.23-11.42c.15-3.81.54-7.59.8-11.37s.55-7.58.75-11.36c.1-1.89.2-3.79.23-5.68a21,21,0,0,0-.1-2.77c-.15-.86-.47-1.82-.67-2.73a35,35,0,0,1-1-5.67,11.53,11.53,0,0,1,.77-5.76c.86-1.71,1.68-3.42,2.67-5.07a13.19,13.19,0,0,1,3.79-4.32,9.52,9.52,0,0,1,5.55-1.33,24.9,24.9,0,0,1,5.64.79,25,25,0,0,0-5.64-.58,9.19,9.19,0,0,0-5.32,1.46,12.91,12.91,0,0,0-3.56,4.26c-.93,1.63-1.72,3.36-2.54,5.07a7.85,7.85,0,0,0-.63,2.64,15.19,15.19,0,0,0,0,2.78,34.06,34.06,0,0,0,1,5.54c.21.93.51,1.79.7,2.79a22.18,22.18,0,0,1,.13,2.91c0,1.91-.1,3.81-.2,5.71-.43,7.59-1.19,15.17-1.74,22.72a75.44,75.44,0,0,0,0,11.35C1396,854.49,1397.16,858.21,1396.94,862Z"
            fill="#44322c"
          />
          <path
            d="M1393.94,825.71a36.69,36.69,0,0,0,0,4.69,7.08,7.08,0,0,1-.28,2.4,6.8,6.8,0,0,1-1.25,2.09c-.25.31-.56.61-.78.9a6,6,0,0,0-.69.88,11.2,11.2,0,0,0-1,2,16.51,16.51,0,0,0-1,4.45,19,19,0,0,0,0,4.58,14.63,14.63,0,0,0,.51,2.22c.24.71.52,1.5.7,2.26a37.53,37.53,0,0,1,1,9.37c-.15-1.56-.34-3.11-.61-4.65a36.39,36.39,0,0,0-1-4.54c-.23-.75-.5-1.43-.77-2.2a14.52,14.52,0,0,1-.57-2.34,19.62,19.62,0,0,1-.13-4.78,17.93,17.93,0,0,1,1.13-4.66,11,11,0,0,1,1.15-2.13,12,12,0,0,1,1.58-1.79,6.15,6.15,0,0,0,1.23-1.86,6.47,6.47,0,0,0,.37-2.22A28.38,28.38,0,0,1,1393.94,825.71Z"
            fill="#44322c"
          />
          <path
            d="M1393.94,765.46c.12.9.3,1.77.5,2.65a12.51,12.51,0,0,1,.46,2.69,5.83,5.83,0,0,1-.14,1.38c0,.23-.13.46-.17.67a2.91,2.91,0,0,0-.06.6A10.68,10.68,0,0,0,1395,776c1,3.4,2,7,1.54,10.74a18.54,18.54,0,0,1-.6,2.7l-.33,1.27-.23,1.3a36.13,36.13,0,0,0-.27,5.31,53.23,53.23,0,0,0,.38,5.35c.2,1.78.48,3.55.82,5.32a47.92,47.92,0,0,1-1.85-10.64,29.24,29.24,0,0,1,.15-5.45l.22-1.35.33-1.34a19.6,19.6,0,0,0,.54-2.57,17.78,17.78,0,0,0-.12-5.25c-.28-1.75-.79-3.46-1.21-5.22a10.66,10.66,0,0,1-.41-2.73,3.21,3.21,0,0,1,.1-.74c.06-.23.14-.41.19-.63a5.59,5.59,0,0,0,.2-1.28,12.59,12.59,0,0,0-.27-2.64A20.27,20.27,0,0,1,1393.94,765.46Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M1490.82,748c8.67-14.32,11.62-17.58,7.94-27.22s-7.23-1.41-3.54-19.56-10.35-23.53-16.73-24.24-36.57,17-31.47,26.65,7.28,37,1.8,39.26S1480.61,764.91,1490.82,748Z"
            fill="#396039"
          />
          <path
            d="M1485,714.73c-.28-7.8,11.48-10.92,7.65-14.46s-8.36-12.76-12.05-7.94-6.52,11.91-9.35,7.94-6-4.11-7.8,0-.28,9.21-4.68,7.94-6.37.71-5.81,5,3.83,2.55,6.66,7.65,15.6,4.4,13.47,1.56S1485,714.73,1485,714.73Z"
            fill="#447244"
          />
          <path
            d="M1507,701.26c6.38-10.06,15.31-19.28,24.24-10.63s-6,24.1,0,30.19,4.68,21.55,0,22.12-26.93.56-32.74,3.26S1485.15,739,1485,729.33,1507,701.26,1507,701.26Z"
            fill="#6b996b"
          />
          <path
            d="M1473.39,760.94c14.93,11.38,16-28.21,0-24.81s-21.27,2.41-26.37-4.68-17.86,5.39-18.29,8.94,3.69,15.45,12.48,18.85S1464.45,754.14,1473.39,760.94Z"
            fill="#447244"
          />
          <path
            d="M1504.25,768.88c-14.94,11.38-16-28.21,0-24.81s21.26,2.41,26.36-4.68,17.86,5.39,18.29,8.93-3.69,15.45-12.48,18.86S1513.18,762.07,1504.25,768.88Z"
            fill="#447244"
          />
          <path
            d="M1522.86,755.27c2.12-4.25,8.36,4,8.36,4s-.42-5.53,3-7.51,5,3.11,5,3.11c.28-4,8.36-.28,6.1,4.44h0a18.94,18.94,0,0,1-8.84,7.9,15.6,15.6,0,0,1-6.32.81l-7.62-1.94S1520.73,759.52,1522.86,755.27Z"
            fill="#396039"
          />
          <path
            d="M1492.1,762.5c-3,5.24-4.68,52.45,0,74.14,0,0-13.61-2.41-17.86-.15-.43,1.42-.43.15-.43.15s18.85-65.64,2.41-84.91-34.3,0-34.3,0,4.82-11.34,15.45-12.2,25.23,12.9,25.94,15.6c0,0,.56-20.7-6.1-27.93s1.85-12.47,1.85-12.47-8.79,2.69,5.38,21.12c7.35,9.55,2.13,27.36,2.13,27.36s4.53-13.89,15.87-10.92,18.15,16.16,28.78,15.31c0,0-12.47-.71-22.4-6.66S1492.1,762.5,1492.1,762.5Z"
            fill="#704d3c"
          />
          <path
            d="M1507.61,760.27a13,13,0,0,0-15.51,2.23c-1,1.81-1.9,8.59-2.42,17.6-3.4-11.75,2.7-25.68,4.63-26.93a10.7,10.7,0,0,1,8.13-.88,24.89,24.89,0,0,1,7.48,3.56Z"
            fill="#634b42"
          />
          <path
            d="M1481.54,755.91c1.56,3.54,3.26,13.93,1.34,19.3h0c-.36-9.73-2.23-18.29-6.66-23.48a31.94,31.94,0,0,0-3-3.05c-.4-1.22-.66-2-.66-2C1475,748,1480,752.36,1481.54,755.91Z"
            fill="#44322c"
          />
          <path
            d="M1504.46,758.07c4.11-1.33,4.37-7.09,9.23-6.76s5.44,7.34,9.48,11.88,7.34,3.54,10.56,5.11-8.82,18.88-20,12.61-10.14-5.19-14-7.75S1495.31,761,1504.46,758.07Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1483.19,749.18c.08.25.08.28,0,.13v-.13Z" fill="#7f2c03" />
            <path
              d="M1483,746.67c-.53-6.58-2-15.28-5.82-19.47a8.52,8.52,0,0,1-2.53-5.12l2-.38c.69,3.15,2.84,7.68,7.81,14.15l.33.44C1484.42,740,1483.26,743.85,1483,746.67Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1467.67,746.16c-2.69-3.38.27-8.32-4-10.73s-8.59,3.11-14.46,4.66-8.08-1.09-11.63-1.56-3.06,20.61,9.75,21.58,11.32,1.27,16,1.27S1473.67,753.69,1467.67,746.16Z"
            fill="#6b996b"
          />
          <path
            d="M1473.08,706.37c2.79-4.4,6.7-8.43,10.6-4.65s-2.6,10.55,0,13.21,2,9.43,0,9.68-11.78.25-14.33,1.43-5.83-3.17-5.89-7.39S1473.08,706.37,1473.08,706.37Z"
            fill="#6b996b"
          />
          <path
            d="M1445.17,755.4c.8,1.22,3.16,1,4.53.44s2.15-4.74,4.36-4,3.27,2.91,5.73,2.2,1.38-3.34,4.52-3.39c2.9,0,5.83,1.14,5.93,2.76,0,.14,0,.27,0,.4h0a2.18,2.18,0,0,0,0,.38c-.57,4.15-3.91,7.21-6.84,7.2-4.64,0-3.16-.31-16-1.27a10.36,10.36,0,0,1-4.72-1.5C1441.24,757.68,1444.36,754.18,1445.17,755.4Z"
            fill="#447244"
          />
          <path
            d="M1502.73,773.13c3.12,0,9.35,3.4,10.2.28s7.09-3.82,7.8-2.41,4.54,3.26,6.66,2.13,4.26,1.7,3.29,2.82c-4,4.46-10.6,8.53-17,5-7.78-4.34-9.64-5.16-11.35-6.1C1501.61,774.27,1500.34,773.13,1502.73,773.13Z"
            fill="#396039"
          />
          <path
            d="M1491.1,737.27c2-4.4,6.81-3.55,10.21-3s2.41,5.1,5.1,3,8.65,3,6.4,6.66h0c-6,.42-11.78,1.08-14.33,2.27-3.6,1.66-7.85-1.51-10.6-6.45l-1.2-2.5h0S1489.12,741.66,1491.1,737.27Z"
            fill="#447244"
          />
          <path
            d="M1527.11,734.57c-1.28-4,4.39-7.37,0-7.37s-11.62,4.4-10.91-2-1.28-9.78-6.1-9.36-8.5-9.92-5.81-12.26-15,4.46-7.23,11.13,10.63,4.53,10.35,7.65,0,9.64,5.95,10.63-1.69,9.08,2.77,10.92S1530.51,745.2,1527.11,734.57Z"
            fill="#447244"
          />
          <path
            d="M1473.81,836.64s1.17-4.07,2.67-10.48c11.84-6.08,12.69-25.85,12.71-26.44.06,13.44.89,27.56,2.91,36.92,0,0-13.61-2.41-17.86-.15C1473.81,837.91,1473.81,836.64,1473.81,836.64Z"
            fill="#44322c"
          />
          <path
            d="M1487.94,836c.08-3.83-1.25-7.46-1.74-11.25a75.11,75.11,0,0,1-.23-11.42c.15-3.81.54-7.59.8-11.37s.55-7.58.75-11.36c.1-1.89.2-3.79.23-5.68a21,21,0,0,0-.1-2.77c-.15-.86-.47-1.82-.67-2.73a35,35,0,0,1-1-5.67,11.53,11.53,0,0,1,.77-5.76c.86-1.71,1.68-3.42,2.67-5.07a13.19,13.19,0,0,1,3.79-4.32,9.52,9.52,0,0,1,5.55-1.33,24.9,24.9,0,0,1,5.64.79,25,25,0,0,0-5.64-.58,9.19,9.19,0,0,0-5.32,1.46,12.91,12.91,0,0,0-3.56,4.26c-.93,1.63-1.72,3.36-2.54,5.07a7.85,7.85,0,0,0-.63,2.64,15.19,15.19,0,0,0,0,2.78,34.06,34.06,0,0,0,1,5.54c.21.93.51,1.79.7,2.79a22.18,22.18,0,0,1,.13,2.91c0,1.91-.1,3.81-.2,5.71-.43,7.59-1.19,15.17-1.74,22.72a75.44,75.44,0,0,0,0,11.35C1487,828.49,1488.16,832.21,1487.94,836Z"
            fill="#44322c"
          />
          <path
            d="M1484.94,799.71a36.69,36.69,0,0,0,0,4.69,7.08,7.08,0,0,1-.28,2.4,6.8,6.8,0,0,1-1.25,2.09c-.25.31-.56.61-.78.9a6,6,0,0,0-.69.88,11.2,11.2,0,0,0-1,2,16.51,16.51,0,0,0-1,4.45,19,19,0,0,0,0,4.58,14.63,14.63,0,0,0,.51,2.22c.24.71.52,1.5.7,2.26a37.53,37.53,0,0,1,1,9.37c-.15-1.56-.34-3.11-.61-4.65a36.39,36.39,0,0,0-1-4.54c-.23-.75-.5-1.43-.77-2.2a14.52,14.52,0,0,1-.57-2.34,19.62,19.62,0,0,1-.13-4.78,17.93,17.93,0,0,1,1.13-4.66,11,11,0,0,1,1.15-2.13,12,12,0,0,1,1.58-1.79,6.15,6.15,0,0,0,1.23-1.86,6.47,6.47,0,0,0,.37-2.22A28.38,28.38,0,0,1,1484.94,799.71Z"
            fill="#44322c"
          />
          <path
            d="M1484.94,739.46c.12.9.3,1.77.5,2.65a12.51,12.51,0,0,1,.46,2.69,5.83,5.83,0,0,1-.14,1.38c0,.23-.13.46-.17.67a2.91,2.91,0,0,0-.06.6A10.68,10.68,0,0,0,1486,750c1,3.4,2,7,1.54,10.74a18.54,18.54,0,0,1-.6,2.7l-.33,1.27-.23,1.3a36.13,36.13,0,0,0-.27,5.31,53.23,53.23,0,0,0,.38,5.35c.2,1.78.48,3.55.82,5.32a47.92,47.92,0,0,1-1.85-10.64,29.24,29.24,0,0,1,.15-5.45l.22-1.35.33-1.34a19.6,19.6,0,0,0,.54-2.57,17.78,17.78,0,0,0-.12-5.25c-.28-1.75-.79-3.46-1.21-5.22a10.66,10.66,0,0,1-.41-2.73,3.21,3.21,0,0,1,.1-.74c.06-.23.14-.41.19-.63a5.59,5.59,0,0,0,.2-1.28,12.59,12.59,0,0,0-.27-2.64A20.27,20.27,0,0,1,1484.94,739.46Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M1592.82,725c8.67-14.32,11.62-17.58,7.94-27.22s-7.23-1.41-3.54-19.56-10.35-23.53-16.73-24.24-36.57,17-31.47,26.65,7.28,37,1.8,39.26S1582.61,741.91,1592.82,725Z"
            fill="#396039"
          />
          <path
            d="M1587,691.73c-.28-7.8,11.48-10.92,7.65-14.46s-8.36-12.76-12.05-7.94-6.52,11.91-9.35,7.94-6-4.11-7.8,0-.28,9.21-4.68,7.94-6.37.71-5.81,5,3.83,2.55,6.66,7.65,15.6,4.4,13.47,1.56S1587,691.73,1587,691.73Z"
            fill="#447244"
          />
          <path
            d="M1609,678.26c6.38-10.06,15.31-19.28,24.24-10.63s-6,24.1,0,30.19,4.68,21.55,0,22.12-26.93.56-32.74,3.26S1587.15,716,1587,706.33,1609,678.26,1609,678.26Z"
            fill="#6b996b"
          />
          <path
            d="M1575.39,737.94c14.93,11.38,16-28.21,0-24.81s-21.27,2.41-26.37-4.68-17.86,5.39-18.29,8.94,3.69,15.45,12.48,18.85S1566.45,731.14,1575.39,737.94Z"
            fill="#447244"
          />
          <path
            d="M1606.25,745.88c-14.94,11.38-16-28.21,0-24.81s21.26,2.41,26.36-4.68,17.86,5.39,18.29,8.93-3.69,15.45-12.48,18.86S1615.18,739.07,1606.25,745.88Z"
            fill="#447244"
          />
          <path
            d="M1624.86,732.27c2.12-4.25,8.36,4,8.36,4s-.42-5.53,3-7.51,5,3.11,5,3.11c.28-4,8.36-.28,6.1,4.44h0a18.94,18.94,0,0,1-8.84,7.9,15.6,15.6,0,0,1-6.32.81l-7.62-1.94S1622.73,736.52,1624.86,732.27Z"
            fill="#396039"
          />
          <path
            d="M1594.1,739.5c-3,5.24-4.68,52.45,0,74.14,0,0-13.61-2.41-17.86-.15-.43,1.42-.43.15-.43.15s18.85-65.64,2.41-84.91-34.3,0-34.3,0,4.82-11.34,15.45-12.2,25.23,12.9,25.94,15.6c0,0,.56-20.7-6.1-27.93s1.85-12.47,1.85-12.47-8.79,2.69,5.38,21.12c7.35,9.55,2.13,27.36,2.13,27.36s4.53-13.89,15.87-10.92,18.15,16.16,28.78,15.31c0,0-12.47-.71-22.4-6.66S1594.1,739.5,1594.1,739.5Z"
            fill="#704d3c"
          />
          <path
            d="M1609.61,737.27a13,13,0,0,0-15.51,2.23c-1,1.81-1.9,8.59-2.42,17.6-3.4-11.75,2.7-25.68,4.63-26.93a10.7,10.7,0,0,1,8.13-.88,24.89,24.89,0,0,1,7.48,3.56Z"
            fill="#634b42"
          />
          <path
            d="M1583.54,732.91c1.56,3.54,3.26,13.93,1.34,19.3h0c-.36-9.73-2.23-18.29-6.66-23.48a31.94,31.94,0,0,0-3-3.05c-.4-1.22-.66-2-.66-2C1577,725,1582,729.36,1583.54,732.91Z"
            fill="#44322c"
          />
          <path
            d="M1606.46,735.07c4.11-1.33,4.37-7.09,9.23-6.76s5.44,7.34,9.48,11.88,7.34,3.54,10.56,5.11-8.82,18.88-20,12.61-10.14-5.19-14-7.75S1597.31,738,1606.46,735.07Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1585.19,726.18c.08.25.08.28,0,.13v-.13Z" fill="#7f2c03" />
            <path
              d="M1585,723.67c-.53-6.58-2-15.28-5.82-19.47a8.52,8.52,0,0,1-2.53-5.12l2-.38c.69,3.15,2.84,7.68,7.81,14.15l.33.44C1586.42,717,1585.26,720.85,1585,723.67Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1569.67,723.16c-2.69-3.38.27-8.32-4-10.73s-8.59,3.11-14.46,4.66-8.08-1.09-11.63-1.56-3.06,20.61,9.75,21.58,11.32,1.27,16,1.27S1575.67,730.69,1569.67,723.16Z"
            fill="#6b996b"
          />
          <path
            d="M1575.08,683.37c2.79-4.4,6.7-8.43,10.6-4.65s-2.6,10.55,0,13.21,2,9.43,0,9.68-11.78.25-14.33,1.43-5.83-3.17-5.89-7.39S1575.08,683.37,1575.08,683.37Z"
            fill="#6b996b"
          />
          <path
            d="M1547.17,732.4c.8,1.22,3.16,1,4.53.44s2.15-4.74,4.36-4,3.27,2.91,5.73,2.2,1.38-3.34,4.52-3.39c2.9,0,5.83,1.14,5.93,2.76,0,.14,0,.27,0,.4h0a2.18,2.18,0,0,0,0,.38c-.57,4.15-3.91,7.21-6.84,7.2-4.64,0-3.16-.31-16-1.27a10.36,10.36,0,0,1-4.72-1.5C1543.24,734.68,1546.36,731.18,1547.17,732.4Z"
            fill="#447244"
          />
          <path
            d="M1604.73,750.13c3.12,0,9.35,3.4,10.2.28s7.09-3.82,7.8-2.41,4.54,3.26,6.66,2.13,4.26,1.7,3.29,2.82c-4,4.46-10.6,8.53-17,5-7.78-4.34-9.64-5.16-11.35-6.1C1603.61,751.27,1602.34,750.13,1604.73,750.13Z"
            fill="#396039"
          />
          <path
            d="M1593.1,714.27c2-4.4,6.81-3.55,10.21-3s2.41,5.1,5.1,3,8.65,3,6.4,6.66h0c-6,.42-11.78,1.08-14.33,2.27-3.6,1.66-7.85-1.51-10.6-6.45l-1.2-2.5h0S1591.12,718.66,1593.1,714.27Z"
            fill="#447244"
          />
          <path
            d="M1629.11,711.57c-1.28-4,4.39-7.37,0-7.37s-11.62,4.4-10.91-2-1.28-9.78-6.1-9.36-8.5-9.92-5.81-12.26-15,4.46-7.23,11.13,10.63,4.53,10.35,7.65,0,9.64,5.95,10.63-1.69,9.08,2.77,10.92S1632.51,722.2,1629.11,711.57Z"
            fill="#447244"
          />
          <path
            d="M1575.81,813.64s1.17-4.07,2.67-10.48c11.84-6.08,12.69-25.85,12.71-26.44.06,13.44.89,27.56,2.91,36.92,0,0-13.61-2.41-17.86-.15C1575.81,814.91,1575.81,813.64,1575.81,813.64Z"
            fill="#44322c"
          />
          <path
            d="M1589.94,813c.08-3.83-1.25-7.46-1.74-11.25a75.11,75.11,0,0,1-.23-11.42c.15-3.81.54-7.59.8-11.37s.55-7.58.75-11.36c.1-1.89.2-3.79.23-5.68a21,21,0,0,0-.1-2.77c-.15-.86-.47-1.82-.67-2.73a35,35,0,0,1-1-5.67,11.53,11.53,0,0,1,.77-5.76c.86-1.71,1.68-3.42,2.67-5.07a13.19,13.19,0,0,1,3.79-4.32,9.52,9.52,0,0,1,5.55-1.33,24.9,24.9,0,0,1,5.64.79,25,25,0,0,0-5.64-.58,9.19,9.19,0,0,0-5.32,1.46,12.91,12.91,0,0,0-3.56,4.26c-.93,1.63-1.72,3.36-2.54,5.07a7.85,7.85,0,0,0-.63,2.64,15.19,15.19,0,0,0,0,2.78,34.06,34.06,0,0,0,1,5.54c.21.93.51,1.79.7,2.79a22.18,22.18,0,0,1,.13,2.91c0,1.91-.1,3.81-.2,5.71-.43,7.59-1.19,15.17-1.74,22.72a75.44,75.44,0,0,0,0,11.35C1589,805.49,1590.16,809.21,1589.94,813Z"
            fill="#44322c"
          />
          <path
            d="M1586.94,776.71a36.69,36.69,0,0,0,0,4.69,7.08,7.08,0,0,1-.28,2.4,6.8,6.8,0,0,1-1.25,2.09c-.25.31-.56.61-.78.9a6,6,0,0,0-.69.88,11.2,11.2,0,0,0-1,2,16.51,16.51,0,0,0-1,4.45,19,19,0,0,0,0,4.58,14.63,14.63,0,0,0,.51,2.22c.24.71.52,1.5.7,2.26a37.53,37.53,0,0,1,1,9.37c-.15-1.56-.34-3.11-.61-4.65a36.39,36.39,0,0,0-1-4.54c-.23-.75-.5-1.43-.77-2.2a14.52,14.52,0,0,1-.57-2.34,19.62,19.62,0,0,1-.13-4.78,17.93,17.93,0,0,1,1.13-4.66,11,11,0,0,1,1.15-2.13,12,12,0,0,1,1.58-1.79,6.15,6.15,0,0,0,1.23-1.86,6.47,6.47,0,0,0,.37-2.22A28.38,28.38,0,0,1,1586.94,776.71Z"
            fill="#44322c"
          />
          <path
            d="M1586.94,716.46c.12.9.3,1.77.5,2.65a12.51,12.51,0,0,1,.46,2.69,5.83,5.83,0,0,1-.14,1.38c0,.23-.13.46-.17.67a2.91,2.91,0,0,0-.06.6A10.68,10.68,0,0,0,1588,727c1,3.4,2,7,1.54,10.74a18.54,18.54,0,0,1-.6,2.7l-.33,1.27-.23,1.3a36.13,36.13,0,0,0-.27,5.31,53.23,53.23,0,0,0,.38,5.35c.2,1.78.48,3.55.82,5.32a47.92,47.92,0,0,1-1.85-10.64,29.24,29.24,0,0,1,.15-5.45l.22-1.35.33-1.34a19.6,19.6,0,0,0,.54-2.57,17.78,17.78,0,0,0-.12-5.25c-.28-1.75-.79-3.46-1.21-5.22a10.66,10.66,0,0,1-.41-2.73,3.21,3.21,0,0,1,.1-.74c.06-.23.14-.41.19-.63a5.59,5.59,0,0,0,.2-1.28,12.59,12.59,0,0,0-.27-2.64A20.27,20.27,0,0,1,1586.94,716.46Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M454.84,663.45c2.11-3.49,2.83-4.29,1.93-6.64s-1.76-.34-.86-4.76-2.52-5.74-4.08-5.91-8.91,4.14-7.66,6.49,1.77,9,.43,9.57S452.35,667.56,454.84,663.45Z"
            fill="#396039"
          />
          <path
            d="M453.42,655.33c-.07-1.9,2.8-2.66,1.87-3.53s-2-3.11-2.94-1.93-1.59,2.9-2.28,1.93-1.45-1-1.9,0-.07,2.25-1.14,1.94-1.55.17-1.41,1.21.93.62,1.62,1.86,3.8,1.07,3.28.38S453.42,655.33,453.42,655.33Z"
            fill="#447244"
          />
          <path
            d="M458.78,652.05c1.55-2.46,3.73-4.7,5.91-2.6s-1.46,5.88,0,7.36,1.14,5.25,0,5.39-6.57.14-8,.8-3.25-1.77-3.29-4.11S458.78,652.05,458.78,652.05Z"
            fill="#6b996b"
          />
          <path
            d="M450.59,666.59c3.64,2.77,3.9-6.88,0-6.05s-5.18.59-6.42-1.14-4.36,1.32-4.46,2.18a5.58,5.58,0,0,0,3,4.59C444.89,667,448.41,664.93,450.59,666.59Z"
            fill="#447244"
          />
          <path
            d="M458.11,668.52c-3.64,2.78-3.9-6.87,0-6s5.18.59,6.43-1.14,4.35,1.31,4.45,2.17a5.57,5.57,0,0,1-3,4.6C463.81,668.94,460.29,666.87,458.11,668.52Z"
            fill="#447244"
          />
          <path
            d="M462.65,665.21c.52-1,2,1,2,1s-.11-1.34.72-1.83,1.21.76,1.21.76c.07-1,2-.07,1.49,1.08h0a4.61,4.61,0,0,1-2.16,1.93,3.84,3.84,0,0,1-1.54.2l-1.85-.48A4.41,4.41,0,0,1,462.65,665.21Z"
            fill="#396039"
          />
          <path
            d="M455.15,667c-.72,1.28-1.14,12.78,0,18.07,0,0-3.32-.59-4.35,0-.11.35-.11,0-.11,0s4.6-16,.59-20.7-8.36,0-8.36,0,1.18-2.76,3.77-3,6.15,3.15,6.32,3.8c0,0,.14-5-1.49-6.8a1.9,1.9,0,0,1,.45-3s-2.14.65,1.32,5.14c1.79,2.33.51,6.67.51,6.67s1.11-3.38,3.87-2.66,4.42,3.94,7,3.73a13.58,13.58,0,0,1-5.46-1.62A3.2,3.2,0,0,0,455.15,667Z"
            fill="#704d3c"
          />
          <path
            d="M458.93,666.43a3.17,3.17,0,0,0-3.78.54,16,16,0,0,0-.59,4.29c-.83-2.87.66-6.26,1.13-6.56a2.56,2.56,0,0,1,2-.22,6.28,6.28,0,0,1,1.83.87Z"
            fill="#634b42"
          />
          <path
            d="M452.58,665.36a8.69,8.69,0,0,1,.33,4.71h0c-.09-2.38-.55-4.46-1.63-5.73a8.49,8.49,0,0,0-.72-.74l-.16-.48A6.18,6.18,0,0,1,452.58,665.36Z"
            fill="#44322c"
          />
          <path
            d="M458.16,665.89c1-.32,1.07-1.73,2.25-1.65s1.33,1.79,2.31,2.9,1.79.86,2.58,1.24-2.15,4.6-4.89,3.08-2.47-1.27-3.41-1.89S455.93,666.61,458.16,665.89Z"
            fill="#6b996b"
          />
          <g>
            <path d="M453,663.72q0,.09,0,0v0Z" fill="#7f2c03" />
            <path
              d="M452.94,663.11c-.13-1.6-.48-3.72-1.42-4.74a2.1,2.1,0,0,1-.61-1.25l.47-.09a9.41,9.41,0,0,0,1.91,3.44.44.44,0,0,0,.08.11C453.28,661.49,453,662.42,452.94,663.11Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M449.2,663c-.66-.83.07-2-1-2.62s-2.09.76-3.52,1.14-2-.27-2.83-.38-.75,5,2.37,5.26,2.76.31,3.89.31S450.66,664.82,449.2,663Z"
            fill="#6b996b"
          />
          <path
            d="M450.52,653.29c.68-1.07,1.63-2,2.58-1.13s-.63,2.57,0,3.22.5,2.3,0,2.36a19.79,19.79,0,0,0-3.49.34c-.62.29-1.42-.77-1.44-1.8S450.52,653.29,450.52,653.29Z"
            fill="#6b996b"
          />
          <path
            d="M443.71,665.24c.2.3.77.24,1.11.11s.52-1.16,1.06-1,.8.71,1.4.54.33-.82,1.1-.83,1.42.28,1.45.67a.34.34,0,0,0,0,.1h0a.28.28,0,0,0,0,.09,2,2,0,0,1-1.67,1.76c-1.13,0-.77-.08-3.89-.31a2.65,2.65,0,0,1-1.15-.37C442.76,665.79,443.52,664.94,443.71,665.24Z"
            fill="#447244"
          />
          <path
            d="M457.74,669.56c.76,0,2.28.83,2.49.07s1.73-.93,1.9-.59a1.49,1.49,0,0,0,1.62.52c.52-.28,1,.41.8.69-1,1.08-2.58,2.08-4.14,1.21-1.89-1.06-2.35-1.26-2.76-1.49C457.47,669.84,457.16,669.56,457.74,669.56Z"
            fill="#396039"
          />
          <path
            d="M454.91,660.82c.48-1.07,1.66-.86,2.49-.73s.58,1.25,1.24.73,2.11.73,1.56,1.62h0a13,13,0,0,0-3.49.56c-.88.4-1.92-.37-2.59-1.57l-.29-.61h0S454.43,661.89,454.91,660.82Z"
            fill="#447244"
          />
          <path
            d="M463.68,660.16c-.31-1,1.07-1.79,0-1.79s-2.83,1.07-2.66-.49-.31-2.38-1.48-2.28-2.07-2.41-1.42-3-3.66,1.08-1.76,2.71,2.59,1.1,2.52,1.86,0,2.35,1.45,2.59-.41,2.22.68,2.66S464.51,662.75,463.68,660.16Z"
            fill="#447244"
          />
          <path
            d="M450.69,685s.29-1,.66-2.56c2.88-1.48,3.09-6.3,3.09-6.44a49.52,49.52,0,0,0,.71,9s-3.32-.59-4.35,0C450.69,685.35,450.69,685,450.69,685Z"
            fill="#44322c"
          />
          <path
            d="M454.14,684.89a18.36,18.36,0,0,0-.43-2.74,18.45,18.45,0,0,1,0-2.78c.11-1.86.28-3.7.36-5.54,0-.47.06-.93.06-1.39a3.73,3.73,0,0,0,0-.67c0-.22-.11-.45-.16-.67a4.63,4.63,0,0,1,0-2.78,5.81,5.81,0,0,1,1.56-2.29,2.38,2.38,0,0,1,1.35-.33,6.38,6.38,0,0,1,1.38.2,5.88,5.88,0,0,0-1.38-.14,2.2,2.2,0,0,0-1.29.35,5.71,5.71,0,0,0-1.5,2.27,4.47,4.47,0,0,0,.09,2.68c.05.22.13.43.17.68a4.22,4.22,0,0,1,0,.71c0,.46,0,.92,0,1.39-.11,1.85-.3,3.69-.43,5.53a19.7,19.7,0,0,0,0,2.77A18.11,18.11,0,0,1,454.14,684.89Z"
            fill="#44322c"
          />
          <path
            d="M453.41,676a7.23,7.23,0,0,0,0,1.14,1.42,1.42,0,0,1-.37,1.09,3.13,3.13,0,0,0-.85,2,4.66,4.66,0,0,0,0,1.12,9.28,9.28,0,0,0,.29,1.09,9.27,9.27,0,0,1,.25,2.28,13,13,0,0,0-.4-2.24,6.39,6.39,0,0,1-.33-1.1,5.09,5.09,0,0,1,0-1.17,3.21,3.21,0,0,1,.94-2.09C453.5,677.64,453.21,676.77,453.41,676Z"
            fill="#44322c"
          />
          <path
            d="M453.41,661.36c0,.43.21.84.23,1.29a5.37,5.37,0,0,1-.09.65,3.39,3.39,0,0,0,.12.62,6.12,6.12,0,0,1,.38,2.62c-.06.46-.24.86-.28,1.28a9.44,9.44,0,0,0-.07,1.3,16.29,16.29,0,0,0,.29,2.6,11.91,11.91,0,0,1-.45-2.59,7.37,7.37,0,0,1,0-1.33c.05-.45.22-.87.26-1.29a6.4,6.4,0,0,0-.32-2.55,2.84,2.84,0,0,1-.1-.66,6,6,0,0,0,.12-.65C453.55,662.23,453.41,661.79,453.41,661.36Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M324.84,698.45c2.11-3.49,2.83-4.29,1.93-6.64s-1.76-.34-.86-4.76-2.52-5.74-4.08-5.91-8.91,4.14-7.66,6.49,1.77,9,.43,9.57S322.35,702.56,324.84,698.45Z"
            fill="#396039"
          />
          <path
            d="M323.42,690.33c-.07-1.9,2.8-2.66,1.87-3.53s-2-3.11-2.94-1.93-1.59,2.9-2.28,1.93-1.45-1-1.9,0-.07,2.25-1.14,1.94-1.55.17-1.41,1.21.93.62,1.62,1.86,3.8,1.07,3.28.38S323.42,690.33,323.42,690.33Z"
            fill="#447244"
          />
          <path
            d="M328.78,687.05c1.55-2.46,3.73-4.7,5.91-2.6s-1.46,5.88,0,7.36,1.14,5.25,0,5.39-6.57.14-8,.8-3.25-1.77-3.29-4.11S328.78,687.05,328.78,687.05Z"
            fill="#6b996b"
          />
          <path
            d="M320.59,701.59c3.64,2.77,3.9-6.88,0-6.05s-5.18.59-6.42-1.14-4.36,1.32-4.46,2.18a5.58,5.58,0,0,0,3,4.59C314.89,702,318.41,699.93,320.59,701.59Z"
            fill="#447244"
          />
          <path
            d="M328.11,703.52c-3.64,2.78-3.9-6.87,0-6s5.18.59,6.43-1.14,4.35,1.31,4.45,2.17a5.57,5.57,0,0,1-3,4.6C333.81,703.94,330.29,701.87,328.11,703.52Z"
            fill="#447244"
          />
          <path
            d="M332.65,700.21c.52-1,2,1,2,1s-.11-1.34.72-1.83,1.21.76,1.21.76c.07-1,2-.07,1.49,1.08h0a4.61,4.61,0,0,1-2.16,1.93,3.84,3.84,0,0,1-1.54.2l-1.85-.48A4.41,4.41,0,0,1,332.65,700.21Z"
            fill="#396039"
          />
          <path
            d="M325.15,702c-.72,1.28-1.14,12.78,0,18.07,0,0-3.32-.59-4.35,0-.11.35-.11,0-.11,0s4.6-16,.59-20.7-8.36,0-8.36,0,1.18-2.76,3.77-3,6.15,3.15,6.32,3.8c0,0,.14-5-1.49-6.8a1.9,1.9,0,0,1,.45-3s-2.14.65,1.32,5.14c1.79,2.33.51,6.67.51,6.67s1.11-3.38,3.87-2.66,4.42,3.94,7,3.73a13.58,13.58,0,0,1-5.46-1.62A3.2,3.2,0,0,0,325.15,702Z"
            fill="#704d3c"
          />
          <path
            d="M328.93,701.43a3.17,3.17,0,0,0-3.78.54,16,16,0,0,0-.59,4.29c-.83-2.87.66-6.26,1.13-6.56a2.56,2.56,0,0,1,2-.22,6.28,6.28,0,0,1,1.83.87Z"
            fill="#634b42"
          />
          <path
            d="M322.58,700.36a8.69,8.69,0,0,1,.33,4.71h0c-.09-2.38-.55-4.46-1.63-5.73a8.49,8.49,0,0,0-.72-.74l-.16-.48A6.18,6.18,0,0,1,322.58,700.36Z"
            fill="#44322c"
          />
          <path
            d="M328.16,700.89c1-.32,1.07-1.73,2.25-1.65s1.33,1.79,2.31,2.9,1.79.86,2.58,1.24-2.15,4.6-4.89,3.08-2.47-1.27-3.41-1.89S325.93,701.61,328.16,700.89Z"
            fill="#6b996b"
          />
          <g>
            <path d="M323,698.72q0,.09,0,0v0Z" fill="#7f2c03" />
            <path
              d="M322.94,698.11c-.13-1.6-.48-3.72-1.42-4.74a2.1,2.1,0,0,1-.61-1.25l.47-.09a9.41,9.41,0,0,0,1.91,3.44.44.44,0,0,0,.08.11C323.28,696.49,323,697.42,322.94,698.11Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M319.2,698c-.66-.83.07-2-1-2.62s-2.09.76-3.52,1.14-2-.27-2.83-.38-.75,5,2.37,5.26,2.76.31,3.89.31S320.66,699.82,319.2,698Z"
            fill="#6b996b"
          />
          <path
            d="M320.52,688.29c.68-1.07,1.63-2,2.58-1.13s-.63,2.57,0,3.22.5,2.3,0,2.36a19.79,19.79,0,0,0-3.49.34c-.62.29-1.42-.77-1.44-1.8S320.52,688.29,320.52,688.29Z"
            fill="#6b996b"
          />
          <path
            d="M313.71,700.24c.2.3.77.24,1.11.11s.52-1.16,1.06-1,.8.71,1.4.54.33-.82,1.1-.83,1.42.28,1.45.67a.34.34,0,0,0,0,.1h0a.28.28,0,0,0,0,.09,2,2,0,0,1-1.67,1.76c-1.13,0-.77-.08-3.89-.31a2.65,2.65,0,0,1-1.15-.37C312.76,700.79,313.52,699.94,313.71,700.24Z"
            fill="#447244"
          />
          <path
            d="M327.74,704.56c.76,0,2.28.83,2.49.07s1.73-.93,1.9-.59a1.49,1.49,0,0,0,1.62.52c.52-.28,1,.41.8.69-1,1.08-2.58,2.08-4.14,1.21-1.89-1.06-2.35-1.26-2.76-1.49C327.47,704.84,327.16,704.56,327.74,704.56Z"
            fill="#396039"
          />
          <path
            d="M324.91,695.82c.48-1.07,1.66-.86,2.49-.73s.58,1.25,1.24.73,2.11.73,1.56,1.62h0a13,13,0,0,0-3.49.56c-.88.4-1.92-.37-2.59-1.57l-.29-.61h0S324.43,696.89,324.91,695.82Z"
            fill="#447244"
          />
          <path
            d="M333.68,695.16c-.31-1,1.07-1.79,0-1.79s-2.83,1.07-2.66-.49-.31-2.38-1.48-2.28-2.07-2.41-1.42-3-3.66,1.08-1.76,2.71,2.59,1.1,2.52,1.86,0,2.35,1.45,2.59-.41,2.22.68,2.66S334.51,697.75,333.68,695.16Z"
            fill="#447244"
          />
          <path
            d="M320.69,720s.29-1,.66-2.56c2.88-1.48,3.09-6.3,3.09-6.44a49.52,49.52,0,0,0,.71,9s-3.32-.59-4.35,0C320.69,720.35,320.69,720,320.69,720Z"
            fill="#44322c"
          />
          <path
            d="M324.14,719.89a18.36,18.36,0,0,0-.43-2.74,18.45,18.45,0,0,1,0-2.78c.11-1.86.28-3.7.36-5.54,0-.47.06-.93.06-1.39a3.73,3.73,0,0,0,0-.67c0-.22-.11-.45-.16-.67a4.63,4.63,0,0,1,0-2.78,5.81,5.81,0,0,1,1.56-2.29,2.38,2.38,0,0,1,1.35-.33,6.38,6.38,0,0,1,1.38.2,5.88,5.88,0,0,0-1.38-.14,2.2,2.2,0,0,0-1.29.35,5.71,5.71,0,0,0-1.5,2.27,4.47,4.47,0,0,0,.09,2.68c.05.22.13.43.17.68a4.22,4.22,0,0,1,0,.71c0,.46,0,.92,0,1.39-.11,1.85-.3,3.69-.43,5.53a19.7,19.7,0,0,0,0,2.77A18.11,18.11,0,0,1,324.14,719.89Z"
            fill="#44322c"
          />
          <path
            d="M323.41,711a7.23,7.23,0,0,0,0,1.14,1.42,1.42,0,0,1-.37,1.09,3.13,3.13,0,0,0-.85,2,4.66,4.66,0,0,0,0,1.12,9.28,9.28,0,0,0,.29,1.09,9.27,9.27,0,0,1,.25,2.28,13,13,0,0,0-.4-2.24,6.39,6.39,0,0,1-.33-1.1,5.09,5.09,0,0,1,0-1.17,3.21,3.21,0,0,1,.94-2.09C323.5,712.64,323.21,711.77,323.41,711Z"
            fill="#44322c"
          />
          <path
            d="M323.41,696.36c0,.43.21.84.23,1.29a5.37,5.37,0,0,1-.09.65,3.39,3.39,0,0,0,.12.62,6.12,6.12,0,0,1,.38,2.62c-.06.46-.24.86-.28,1.28a9.44,9.44,0,0,0-.07,1.3,16.29,16.29,0,0,0,.29,2.6,11.91,11.91,0,0,1-.45-2.59,7.37,7.37,0,0,1,0-1.33c.05-.45.22-.87.26-1.29a6.4,6.4,0,0,0-.32-2.55,2.84,2.84,0,0,1-.1-.66,6,6,0,0,0,.12-.65C323.55,697.23,323.41,696.79,323.41,696.36Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M275.57,663.31c1-1.59,1.29-1.95.88-3s-.8-.16-.39-2.17a2.09,2.09,0,0,0-1.85-2.68c-.71-.08-4,1.88-3.48,2.95s.8,4.09.2,4.34S274.44,665.17,275.57,663.31Z"
            fill="#396039"
          />
          <path
            d="M274.93,659.62c0-.86,1.27-1.21.85-1.6s-.93-1.41-1.34-.88-.72,1.32-1,.88-.66-.45-.86,0,0,1-.52.88-.71.08-.64.55.42.28.73.85,1.73.48,1.49.17S274.93,659.62,274.93,659.62Z"
            fill="#447244"
          />
          <path
            d="M277.36,658.13c.71-1.11,1.69-2.13,2.68-1.17s-.66,2.66,0,3.34.52,2.38,0,2.44a19.46,19.46,0,0,0-3.62.36c-.64.3-1.47-.8-1.49-1.86S277.36,658.13,277.36,658.13Z"
            fill="#6b996b"
          />
          <path
            d="M273.64,664.73c1.66,1.26,1.78-3.12,0-2.74s-2.35.27-2.91-.52-2,.6-2,1a2.49,2.49,0,0,0,1.38,2.08C271.06,664.92,272.66,664,273.64,664.73Z"
            fill="#447244"
          />
          <path
            d="M277.06,665.61c-1.65,1.26-1.77-3.12,0-2.74s2.35.26,2.91-.52,2,.6,2,1a2.54,2.54,0,0,1-1.38,2.08C279.64,665.8,278.05,664.86,277.06,665.61Z"
            fill="#447244"
          />
          <path
            d="M279.12,664.11c.23-.47.92.43.92.43s-.05-.61.33-.83.55.35.55.35c0-.44.92,0,.67.49h0a2,2,0,0,1-1,.87,1.78,1.78,0,0,1-.7.09l-.84-.21A2,2,0,0,1,279.12,664.11Z"
            fill="#396039"
          />
          <path
            d="M275.71,664.91c-.33.58-.51,5.8,0,8.2a5,5,0,0,0-2,0c-.05.16-.05,0-.05,0s2.09-7.26.27-9.4-3.8,0-3.8,0a2.29,2.29,0,0,1,1.71-1.34c1.18-.1,2.79,1.42,2.87,1.72,0,0,.06-2.29-.67-3.09a.86.86,0,0,1,.2-1.38s-1,.3.6,2.34c.81,1,.23,3,.23,3s.5-1.53,1.76-1.2,2,1.78,3.18,1.69a6.19,6.19,0,0,1-2.48-.74A1.45,1.45,0,0,0,275.71,664.91Z"
            fill="#704d3c"
          />
          <path
            d="M277.43,664.66a1.44,1.44,0,0,0-1.72.25,7.12,7.12,0,0,0-.26,1.94,3.82,3.82,0,0,1,.51-3,1.17,1.17,0,0,1,.9-.09,2.87,2.87,0,0,1,.83.39Z"
            fill="#634b42"
          />
          <path
            d="M274.55,664.18a3.93,3.93,0,0,1,.15,2.13h0a4.41,4.41,0,0,0-.74-2.6l-.33-.33c0-.14-.07-.22-.07-.22A2.86,2.86,0,0,1,274.55,664.18Z"
            fill="#44322c"
          />
          <path
            d="M277.08,664.42c.46-.15.48-.79,1-.75s.6.81,1,1.31.81.39,1.17.57-1,2.09-2.22,1.39-1.12-.57-1.55-.85A1,1,0,0,1,277.08,664.42Z"
            fill="#6b996b"
          />
          <g>
            <path d="M274.73,663.43s0,0,0,0v0Z" fill="#7f2c03" />
            <path
              d="M274.71,663.16a4.08,4.08,0,0,0-.64-2.16.92.92,0,0,1-.28-.57l.21,0a4.44,4.44,0,0,0,.87,1.57l0,0C274.87,662.42,274.74,662.84,274.71,663.16Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M273,663.1c-.29-.38,0-.92-.44-1.19s-.95.35-1.6.52-.89-.12-1.28-.18-.34,2.28,1.08,2.39,1.25.14,1.76.14A1,1,0,0,0,273,663.1Z"
            fill="#6b996b"
          />
          <path
            d="M273.61,658.7c.31-.49.74-.94,1.17-.52s-.28,1.17,0,1.46.23,1.05,0,1.07a9,9,0,0,0-1.58.16c-.28.13-.65-.35-.65-.81S273.61,658.7,273.61,658.7Z"
            fill="#6b996b"
          />
          <path
            d="M270.52,664.12c.09.14.35.11.5,0s.24-.52.49-.44.36.32.63.24.15-.37.5-.38.65.13.66.31v0h0v0a.88.88,0,0,1-.76.79c-.51,0-.35,0-1.76-.14a1.06,1.06,0,0,1-.52-.16C270.09,664.37,270.43,664,270.52,664.12Z"
            fill="#447244"
          />
          <path
            d="M276.89,666.08c.35,0,1,.38,1.13,0s.78-.42.86-.26a.69.69,0,0,0,.74.23c.23-.12.47.19.36.31a1.54,1.54,0,0,1-1.88.55c-.86-.48-1.06-.57-1.25-.67S276.63,666.08,276.89,666.08Z"
            fill="#396039"
          />
          <path
            d="M275.6,662.11c.22-.48.76-.39,1.13-.32s.27.56.57.32.95.33.71.74h0a6,6,0,0,0-1.59.25c-.4.19-.87-.16-1.17-.71l-.13-.28h0S275.38,662.6,275.6,662.11Z"
            fill="#447244"
          />
          <path
            d="M279.59,661.82c-.14-.44.48-.82,0-.82s-1.29.49-1.21-.22-.14-1.08-.67-1-.94-1.1-.65-1.36-1.66.49-.8,1.23,1.18.5,1.15.85,0,1.06.66,1.17-.19,1,.3,1.21S280,663,279.59,661.82Z"
            fill="#447244"
          />
          <path
            d="M273.69,673.11s.13-.45.3-1.16c1.31-.68,1.4-2.86,1.4-2.93a22.85,22.85,0,0,0,.32,4.09,5,5,0,0,0-2,0C273.69,673.25,273.69,673.11,273.69,673.11Z"
            fill="#44322c"
          />
          <path
            d="M275.25,673a7.43,7.43,0,0,0-.19-1.24,7.7,7.7,0,0,1,0-1.27l.17-2.51a3.43,3.43,0,0,0-.06-1.24,2.08,2.08,0,0,1,0-1.26,2.58,2.58,0,0,1,.71-1,1.66,1.66,0,0,1,1.24-.06,1.62,1.62,0,0,0-1.21.1,2.51,2.51,0,0,0-.68,1,2,2,0,0,0,0,1.21,3.56,3.56,0,0,1,.07,1.26l-.2,2.52a8.7,8.7,0,0,0,0,1.25A7.47,7.47,0,0,1,275.25,673Z"
            fill="#44322c"
          />
          <path
            d="M274.92,669c-.05.33.11.73-.17,1a1.37,1.37,0,0,0-.39.92,2.16,2.16,0,0,0,.14,1,3.65,3.65,0,0,1,.11,1,5.72,5.72,0,0,0-.17-1,2.12,2.12,0,0,1-.17-1,1.47,1.47,0,0,1,.43-1C275,669.75,274.83,669.35,274.92,669Z"
            fill="#44322c"
          />
          <path
            d="M274.92,662.36c0,.2.1.38.11.59a2.26,2.26,0,0,1,0,.29.92.92,0,0,0,.05.28,2.82,2.82,0,0,1,.17,1.19,4.29,4.29,0,0,0-.16,1.17,7.76,7.76,0,0,0,.14,1.18,5.2,5.2,0,0,1-.2-1.18,3.89,3.89,0,0,1,.13-1.18,2.87,2.87,0,0,0-.14-1.16,1.45,1.45,0,0,1-.05-.3A1.6,1.6,0,0,0,275,663C275,662.75,274.92,662.56,274.92,662.36Z"
            fill="#44322c"
          />
        </g>
      </g>
    </g>
  );
};

export default DRMapStaticElements;
